document.addEventListener('DOMContentLoaded', function() {
  var subscribeBtn = document.getElementById('Subscribe');
  if (subscribeBtn) {
    subscribeBtn.addEventListener('click', function() {
      let isValid = true;
      var emailInput = document.getElementById('customer-email');

      if (emailInput) {
        console.log("emailInput", emailInput);
        var emailValue = emailInput.value;
        console.log("emailValue", emailValue);

        var errorElement = document.getElementById('ContactFooter-error');

        if (emailInput.value.trim() === '') {
          if (errorElement) errorElement.style.display = 'block';
          isValid = false;
        }
        else if (emailInput.value.trim() !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim())) {
          if (errorElement) errorElement.style.display = 'block';
          isValid = false;
        } else {
          if (errorElement) errorElement.style.display = 'none';
        }

        if (isValid) {
          var formData = new FormData();
          formData.append('form_type', 'customer');
          formData.append('contact[email]', emailValue);
          formData.append('contact[accepts_marketing]', true);
          formData.append('contact[tags]', 'NewsLetter');

          const xhr = new XMLHttpRequest();
          xhr.open('POST', '/contact#contact_form', true);
          xhr.setRequestHeader('Accept', 'application/json');

          xhr.onreadystatechange = function() {
              if (xhr.readyState === XMLHttpRequest.DONE) {
                  if (xhr.status === 200) {
                    var successMessage = document.getElementById('ContactFooter-success');
                      if (successMessage) {
                          successMessage.style.display = 'block';
                      }
                      var form = document.getElementById('ContactFooter');
                      if (form) form.reset(); // Optionally reset the form
                  } else {
                      // Handle error
                      console.error('There was a problem with your submission. Please try again.');
                  }
              }
          };

          xhr.send(formData);
        }
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', () => {
  // Select the single ul element
  var footerMenu = document.querySelector('.footer-menu ul.footer-block__details-content');

  if (footerMenu) {
    // Get the last li element within the ul
    var lastLi = footerMenu.querySelector('li:last-child');
    if (lastLi) {
      // Get the anchor element within the last li
      var anchor = lastLi.querySelector('a');
      if (anchor) {
        // Set target="_blank" on the anchor element
        anchor.setAttribute('target', '_blank');
      }
    }
  }
});

document.body.addEventListener("click", function(e) {
    if (e.target.matches("summary.facets__summary")) {
        var filter = e.target.closest(".disclosure-has-popup");
        //console.log("filter", filter);
        if (filter) {
            if (filter.classList.contains("close-accordian")) {
                filter.classList.remove("close-accordian");
                filter.classList.add("open-accordian");
            } else {
              //console.log("close")
                filter.classList.add("close-accordian");
                filter.classList.remove("open-accordian");
            }
        }
    }
});

function headerMarquee(){
  var MarqueeCheck = document.querySelector("header .product_title_marquee");
  var attMain = document.querySelector("main").getAttribute("data-barba-namespace");
  if( MarqueeCheck && !MarqueeCheck.classList.contains("doneM") && attMain == 'index' ){
    MarqueeCheck.classList.add("doneM");
    var headerLogoMar = document.querySelectorAll("header .product_title");
      headerLogoMar.forEach(( title ) => {
        const loop = horizontalLoop(title, {
          repeat: -1,
          paused: false,
        });
      });
  }
}
document.addEventListener('DOMContentLoaded', function() {
  //gsap.delayedCall(2.6, function() {
    headerMarquee();
  //})
})

// Function to handle popstate event
function handlePopstate(event) {
    const state = event.state || {};

    // Check if the state is managed by Barba.js
    if (state.from === 'barba') {
    var bStates = state.states
      const last = bStates[bStates.length - 1];
        // Retrieve namespace and custom data from the state
        const namespace = last.ns || '';
        const customData = last.data || {};
       const customURL = last.url || window.location.pathname;

      // console.log('sd', {
      //       state: state,
      //       namespace: namespace,
      //       customData: customData
      //   });
        // Trigger Barba.js transition based on the namespace and custom data
      //console.log("customURL",customURL);
        barba.go(customURL, {
            state: state,
            namespace: namespace,
            customData: customData
        });
    }
}

// Add event listener for popstate event
window.addEventListener('popstate', handlePopstate);

// window.addEventListener('popstate', function(event) {
//   console.log('event.state', event.state);
//   //barba.force('popstate', event.state);
// });

var observer = new MutationObserver(function(mutationsList, observer) {
    // Call your function when mutations occur


    myFunction();
});

// Start observing changes to the document body
observer.observe(document.body, { childList: true, subtree: true });
function myFunction(){
  //console.log("I m here...");
  var trigger_filters = document.querySelector(".trigger_filters");
  if(trigger_filters)
  {
    var shopFiltersElement = document.querySelector(".shop-filters");
    var trigger_filter_close = document.querySelector(".trigger_filter_close");

    trigger_filters.addEventListener("click", function(e) {
      gsap.to(shopFiltersElement, { xPercent: -100, duration: 1 });
      if (window.matchMedia("(max-width: 767px)").matches) {
          var allFilters = document.querySelectorAll(".disclosure-has-popup");
          allFilters.forEach((filter) => {
            filter.classList.remove("open-accordian");
              filter.classList.add("close-accordian");
          });
      }
    });
  }

  function reinitializeEventListeners() {
      // Add any additional event listeners that need to be reattached after search
      var allFilters = document.querySelectorAll(".disclosure-has-popup");
      allFilters.forEach((filter) => {
          filter.classList.remove("open-accordian");
          filter.classList.add("close-accordian");
      });
  }

  // Example function to handle search and reinitialize event listeners
  function performSearch() {
      // Perform search logic here (e.g., AJAX call, DOM manipulation)

      // Once search is completed and DOM is updated, reinitialize event listeners
      reinitializeEventListeners();
  }
  var mainElemtn = document.querySelector("main");
  // var allTitleMaquees = mainElemtn.querySelectorAll(".product_title_marquee");
  // allTitleMaquees.forEach(( marquee ) => {
  //   var productTitles = marquee.querySelectorAll(".product_title");
  //   productTitles.forEach(( title ) => {
  //     const loop = horizontalLoop(title, {
  //       repeat: -1,
  //       paused: false,
  //     });
  //   });
  // })
  //var productCards = mainElemtn.querySelectorAll(".customProductCard .card");
  // productCards.forEach(( productCard ) => {
  //   let ImageOne = productCard.querySelector(".customPCardImage_0");
  //   let ImageTwo = productCard.querySelector(".customPCardImage_1");
  //   if( ImageTwo )
  //   {
  //     gsap.set(ImageOne,{ xPercent:0, opacity:1 });
  //     gsap.set(ImageTwo,{ xPercent:125,opacity:1 });
  //     var tl = new TimelineLite({ paused : true, ease:"none", stagger: 0.1 });
  //     tl.to( ImageOne, 1, {xPercent : -125, duration: 1 });
  //     tl.to( ImageTwo, 1, {xPercent : 0, duration: 1 },0);
  //       productCard.addEventListener("pointerenter", function(e) {
  //         console.log("dd");
  //         if (window.matchMedia("(min-width: 768px)").matches) {
  //           tl.play();
  //         }
  //       })
  //       productCard.addEventListener("pointerleave", function(e) {
  //         if (window.matchMedia("(min-width: 768px)").matches) {
  //           tl.reverse();
  //         }
  //       })
  //   }
  // })

  var att = document.querySelector("main").getAttribute("data-barba-namespace");
  //console.log("att",att);
  var getSearchParam = new URLSearchParams(window.location.search);
  var gimmePromotion = getSearchParam.get('filter.p.m.custom.gimme_promotion');
  var gimmeCollection = getSearchParam.get('filter.p.m.custom.product_collections');

  console.log(gimmeCollection);
  if( att == "collection" )
  {

    if( gimmePromotion == null && gimmeCollection != 'gid://shopify/Metaobject/83235078320' )
    {
      console.log("if");
      document.querySelector("main").classList.remove("gimme-products");
    }
    else{
      console.log("else");
      document.querySelector("main").classList.add("gimme-products");
    }
  }
  if( (att == "collection" || att == "product" ) && document.querySelector("main").classList.contains("gimme-products" ))
  {
    //cmt document.querySelector("body").classList.add("color-background-2");
  }
  else{
    //cmt document.querySelector("body").classList.remove("color-background-2");
  }
  document.querySelector("body").setAttribute('id',att.replace(".", "-"));
  headerMarquee();

  var cartShareItems = document.querySelectorAll(".cart-item__quantity");
  cartShareItems.forEach(( shareItem ) => {
    var shareButton = shareItem.querySelector(".share-button");
    shareButton.classList.remove("active");
    var textToCopy = shareItem.querySelector('.pen-url');
    var shareCopyText = shareItem.querySelector(".share-copy-text");
    gsap.set(shareCopyText,{ yPercent: 100, autoAlpha:0 });
    shareButton.addEventListener("click", function(e){
      e.preventDefault();
      if( !shareButton.classList.contains("active") )
      {
        cartShareItems.forEach(( shareItemRc ) => {
          var shareButtonRc = shareItemRc.querySelector(".share-button");
           var shareCopyTextRc = shareItemRc.querySelector(".share-copy-text");
          gsap.to(shareCopyTextRc,{ yPercent: 100, autoAlpha:0 });
          shareButtonRc.classList.remove("active");
        })
        shareButton.classList.add("active");
        navigator.clipboard.writeText(textToCopy.textContent).then(function () {
            gsap.to(shareCopyText,{ yPercent: 0, autoAlpha:1 })
        }).catch(function (err) {
        });
      }
    })
  })
}

var targetDiv = document.getElementById('cart-icon-bubble');

// Create a new mutation observer
var observer1 = new MutationObserver(function(mutationsList, observer) {
    // Call your function when mutations occur
    carfunction();
});

// Start observing changes to the target div
if( targetDiv ) {
  observer1.observe(targetDiv, { childList: true, subtree: true });
}

// Function to execute when content changes in the target div
function carfunction() {
  // Your function logic here
  var carttotal = targetDiv.querySelector(".cart-count-bubble").getAttribute('carttotal');
  //console.log('Content changed in the target div. Calling myFunction...',carttotal);
  // You can add any code you want to execute when the content changes
  var cartIcons = document.querySelectorAll(".openCart");
  var cartTotalString = carttotal.toString();

  cartIcons.forEach(( cartIcon ) => {

      var caritemUpdate = cartIcon.querySelector("span.linkText");
      var cartMobile = cartIcon.querySelector("span.linkTextMobile");
      if( caritemUpdate )
      {
        caritemUpdate.innerHTML = 'Cart [' + cartTotalString + ']';
      }
      if( cartMobile )
      {
        cartMobile.innerHTML = 'Cart [' + cartTotalString + ']';
      }

    });
  setTimeout(() => {
    var allMqs = document.querySelectorAll(".product_title_cart_marquee_inner");
    allMqs.forEach(( mq ) => {

      if( !mq.classList.contains("marqueeLoaded") ){
        mq.classList.add("marqueeLoaded");
        //console.log("ff");
        var productTitlesAll = mq.querySelectorAll(".product_title_cart_marquee_part");
        productTitlesAll.forEach(( tile ) => {
          const loop = horizontalLoop(tile, {
            repeat: -1,
            paused: false,
          });
        });
      }
    })
  },1000);
}



  var cartIcons = document.querySelectorAll(".openCart");
  var cartBubble = document.getElementById("cart-icon-bubble");
  cartIcons.forEach(( cartIcon ) => {
    var carttotal = cartBubble ? cartBubble.getAttribute('carttotal') : null;
    var cartTotalString = carttotal ? carttotal.toString() : '';
    var caritemUpdate = cartIcon.querySelector("span.linkText");
    var cartMobile = cartIcon.querySelector("span.linkTextMobile");
    if( caritemUpdate )
    {
      caritemUpdate.innerHTML = 'Cart [' + cartTotalString + ']';
    }
    if( cartMobile )
    {
      cartMobile.innerHTML = 'Cart [' + cartTotalString + ']';
    }
    cartIcon.addEventListener("click", function(e){
      if( cartBubble ) cartBubble.click();
    })
  });

  const menuIcons = document.querySelectorAll("a.openMenu");
  const menuItems = document.querySelector(".circleMenu");
  gsap.set(menuItems,{ scale: 0.35, autoAlpha:0 });
  var allNavItems = document.querySelectorAll(".circleMenu .list-menu li a")
  gsap.set(".circleMenu .list-menu li a span",{ yPercent: 100, autoAlpha:0 });
  allNavItems.forEach(( item, index ) => {
    //console.log(allNavItems[1]);
    if( index==1 )
    {
      gsap.set(item,{ scale: 0.51, autoAlpha:1 });
    }
    if( index==2 )
    {
      gsap.set(item,{ scale: 0.34, autoAlpha:1 });
    }

    if( index==3 )
    {
      gsap.set(item,{ scale: 0.24, autoAlpha:1 });
    }
    if( index==6 )
    {
      gsap.set(item,{ scale: 0.2, autoAlpha:1 });
    }
  })
  function menuOpenClose(){
      menuOpenCloseFooter();
      menuOpenCloseMobile();

      menuIcons.forEach(( menuIcon ) => {
        menuIcon.addEventListener("click", function(e){
          if( menuIcon.classList.contains("active") )
          {
            menuIcons.forEach(( menuIconClass ) => {
              menuIconClass.classList.remove("active");
            })
            // gsap.to(".circleMenu .list-menu li a span",{ yPercent: 100, autoAlpha:0 });
            // gsap.set(menuItems,{ scale: 0.35, autoAlpha:0 });

            gsap.to(".circleMenu .list-menu li a span",{ yPercent: 100, autoAlpha:0, duration:0.5 });
            gsap.to(allNavItems[6],{ delay:0.5, scale: 0.2, autoAlpha:1, duration: 0.8 });
            gsap.to(allNavItems[3],{ delay:0.5, scale: 0.24, autoAlpha:1, duration: 0.8 });
            gsap.to(allNavItems[2],{ delay:0.5, scale: 0.34, autoAlpha:1, duration: 0.8 });
            gsap.to(allNavItems[1],{ delay:0.5, scale: 0.51, autoAlpha:1, duration: 0.8});
            gsap.set(menuItems,{ delay:1.3, scale: 0.35, autoAlpha:0 });

          }
          else
          {
            // var getGrid = document.getElementById("HeaderMenu-about");
            // //console.log("getGrid",getGrid);
            // var gridHtml = getGrid.querySelector(".full-grid").innerHTML;
            // allNavItems[5].innerHTML = '<div class="full-grid">'+gridHtml+'</div><div class="linkWrap"><span class="linkText">Cart</span></div>';
            // var spanNavCart = allNavItems[5].querySelector('span');
            // gsap.set(spanNavCart,{ yPercent: 100, autoAlpha:0 });


            menuIcons.forEach(( menuIconClass ) => {
              menuIconClass.classList.add("active");
            })
            gsap.set(menuItems,{ scale: 1, autoAlpha:1 });
            gsap.to(allNavItems[1],{ scale: 1, autoAlpha:1, duration: 0.7 });
            gsap.to(allNavItems[2],{ scale: 1, autoAlpha:1, duration: 1 });
            gsap.to(allNavItems[3],{ scale: 1, autoAlpha:1, duration: 1 });
            gsap.to(allNavItems[6],{ scale: 1, autoAlpha:1, duration: 1 });
            gsap.to(".circleMenu .list-menu li a span",{ delay:0.8, duration:0.5, yPercent: 0, autoAlpha:1 });

            // gsap.to(allNavItems[1],{ scale: 1, autoAlpha:1, duration: 0.7 });
            // gsap.to(allNavItems[2],{ scale: 1, autoAlpha:1, duration: 1.1 });
            // gsap.to(allNavItems[3],{ scale: 1, autoAlpha:1, duration: 1.5 });
            // gsap.to(allNavItems[5],{ scale: 1, autoAlpha:1, duration: 1.9 });
            // gsap.to(".circleMenu .list-menu li a span",{ delay:1.7, duration:0.5, yPercent: 0, autoAlpha:1 });
          }
        })
      })
  }

  const menuIconsFooter = document.querySelectorAll("a.openMenuFooter");
  const menuItemsFooter = document.querySelector(".circleMenuFooter");
  gsap.set(menuItemsFooter,{ scale: 0.35, autoAlpha:0 });
  var allNavItemsFooter = document.querySelectorAll(".circleMenuFooter li a")
  gsap.set(".circleMenuFooter li a span",{ yPercent: 100, autoAlpha:0 });
  allNavItemsFooter.forEach(( item, index ) => {
    if( index==1 )
    {
      gsap.set(item,{ scale: 0.51, autoAlpha:1 });
    }
    if( index==2 )
    {
      gsap.set(item,{ scale: 0.34, autoAlpha:1 });
    }

    if( index==3 )
    {
      gsap.set(item,{ scale: 0.24, autoAlpha:1 });
    }
    if( index==5 )
    {
      gsap.set(item,{ scale: 0.2, autoAlpha:1 });
    }
    if( index==6 )
    {
      gsap.set(item,{ scale: 0.14, autoAlpha:1 });
    }
  })
  function menuOpenCloseFooter(){


      menuIconsFooter.forEach(( menuIcon ) => {
        menuIcon.addEventListener("click", function(e){
              //console.log("allNavItemsFooter",allNavItemsFooter);

          if( menuIcon.classList.contains("active") )
          {
            menuIconsFooter.forEach(( menuIconClass ) => {
              menuIconClass.classList.remove("active");
            })


            gsap.to(".circleMenuFooter li a span",{ yPercent: 100, autoAlpha:0, duration:0.5 });
            gsap.to(allNavItemsFooter[6],{ delay:0.5, scale: 0.14, autoAlpha:1, duration: 0.8 });
            gsap.to(allNavItemsFooter[5],{ delay:0.5, scale: 0.2, autoAlpha:1, duration: 0.8 });
            gsap.to(allNavItemsFooter[3],{ delay:0.5, scale: 0.24, autoAlpha:1, duration: 0.8 });
            gsap.to(allNavItemsFooter[2],{ delay:0.5, scale: 0.34, autoAlpha:1, duration: 0.8 });
            gsap.to(allNavItemsFooter[1],{ delay:0.5, scale: 0.51, autoAlpha:1, duration: 0.8});
            gsap.set(menuItemsFooter,{ delay:1.3, scale: 0.35, autoAlpha:0 });

          }
          else
          {
            // var getGrid = document.getElementById("HeaderMenu-about");
            // //console.log("getGrid",getGrid);
            // var gridHtml = getGrid.querySelector(".full-grid").innerHTML;
            // allNavItemsFooter[5].innerHTML = '<div class="full-grid">'+gridHtml+'</div><div class="linkWrap"><span class="linkText">Cart</span></div>';
            // var spanNavCartFooter = allNavItemsFooter[5].querySelector('span');
            // gsap.set(spanNavCartFooter,{ yPercent: 100, autoAlpha:0 });


            menuIconsFooter.forEach(( menuIconClass ) => {
              menuIconClass.classList.add("active");
            })
            gsap.set(menuItemsFooter,{ scale: 1, autoAlpha:1 });
            gsap.to(allNavItemsFooter[1],{ scale: 1, autoAlpha:1, duration: 0.7 });
            gsap.to(allNavItemsFooter[2],{ scale: 1, autoAlpha:1, duration: 1 });
            gsap.to(allNavItemsFooter[3],{ scale: 1, autoAlpha:1, duration: 1 });
            gsap.to(allNavItemsFooter[5],{ scale: 1, autoAlpha:1, duration: 1 });
            gsap.to(allNavItemsFooter[6],{ scale: 1, autoAlpha:1, duration: 1 });
            gsap.to(".circleMenuFooter li a span",{ delay:0.8, duration:0.5, yPercent: 0, autoAlpha:1 });
          }
        })
      })
  }



  const menuIconsMobile = document.querySelectorAll("a.openMenuMobile");
  const menuItemsMobile = document.querySelector(".circleMenuMobile");
  gsap.set(menuItemsMobile,{ scale: 0, autoAlpha:0, zIndex:9999 });
  var allNavItemsMobile = document.querySelectorAll(".circleMenuMobile li a")
  gsap.set(".circleMenuMobile li a span",{ yPercent: 100, autoAlpha:0 });
  allNavItemsMobile.forEach(( item, index ) => {
    gsap.set(item,{ scale: 0.5, autoAlpha:0 });
  })
  function menuOpenCloseMobile(){

      menuIconsMobile.forEach(( menuIcon ) => {
        menuIcon.addEventListener("click", function(e){
          if( menuIcon.classList.contains("active") )
          {
            menuIconsMobile.forEach(( menuIconClass ) => {
              menuIconClass.classList.remove("active");
            })
            menuItemsMobile.classList.remove("fillbg");
            document.querySelector("body").classList.remove("mobilemenuopen");
            gsap.to(".circleMenuMobile li a span",{ yPercent: 100, autoAlpha:0, duration:0.5 });
            gsap.to(allNavItemsMobile,{ delay:0.3,scale: 0.5, autoAlpha:0, duration: 1 });
            // gsap.to(allNavItemsMobile[3],{ delay:0.5, scale: 0.24, autoAlpha:1, duration: 0.8 });
            // gsap.to(allNavItemsMobile[2],{ delay:0.5, scale: 0.34, autoAlpha:1, duration: 0.8 });
            // gsap.to(allNavItemsMobile[1],{ delay:0.5, scale: 0.51, autoAlpha:1, duration: 0.8});
            gsap.set(menuItemsMobile,{ delay:1.5, scale: 0, autoAlpha:0 });

          }
          else
          {
            document.querySelector("body").classList.add("mobilemenuopen");
            // var getGrid = document.getElementById("HeaderMenu-about");
            // //console.log("getGrid",getGrid);
            // var gridHtml = getGrid.querySelector(".full-grid").innerHTML;
            // allNavItemsMobile[5].innerHTML = '<div class="full-grid">'+gridHtml+'</div><div class="linkWrap"><span class="linkText">Cart</span></div>';
            // var spanNavCart = allNavItemsMobile[5].querySelector('span');
            // gsap.set(spanNavCart,{ yPercent: 100, autoAlpha:0 });


            menuIconsMobile.forEach(( menuIconClass ) => {
              menuIconClass.classList.add("active");
            })
            gsap.set(menuItemsMobile,{ scale: 1, autoAlpha:1 });
            gsap.to(allNavItemsMobile,{ scale: 1, autoAlpha:1, duration: 1, onComplete:function(){
              menuItemsMobile.classList.add("fillbg");
            } });
            // gsap.to(allNavItemsMobile[2],{ scale: 1, autoAlpha:1, duration: 0.7 });
            // gsap.to(allNavItemsMobile[3],{ scale: 1, autoAlpha:1, duration: 0.7 });
            // gsap.to(allNavItemsMobile[5],{ scale: 1, autoAlpha:1, duration: 0.7 });
            gsap.to(".circleMenuMobile  li a span",{ delay:0.8, duration:0.5, yPercent: 0, autoAlpha:1 });
          }
        })
      })
  }

  menuOpenClose();






function progressBarShow() {
  const w = document.querySelector('.progress');
  const p = document.querySelector('.progress-bar');
  const pbtl = gsap.timeline();
  pbtl.fromTo(p, { width: 0, display: 'block' }, {
      width: '100%',
      display: 'none',
      duration: 0.8,
  });
}

function transition() {
  let tl = gsap.timeline();

  tl.to(".page-transition", {
    duration: 0.5,
    scaleX: 1,
    transformOrigin: "bottom right",
    stagger: 0.2,
  });
  tl.to(".page-transition", {
    duration: 0.5,
    scaleX: 0,
    transformOrigin: "bottom right",
    stagger: 0.1,
    delay: 0.1,
  });
}

const svgLogo = document.querySelector("a.openMenu.logo");
const logoSide1 = document.querySelector(".headerMain .logoSide1");
const logoSide2 = document.querySelector(".headerMain .logoSide2");

const logoSide3 = document.querySelector(".galleryheader1 .logoSide1");
const logoSide4 = document.querySelector(".galleryheader1 .logoSide2");



// Define the pointerenter event handler
function onPointerEnter() {

  if (!svgLogo.classList.contains("active")) {
    var logo = svgLogo.querySelector("svg");
    gsap.to(logo, 1, { startAt: { rotation: 0 }, rotation: 360 });
    gsap.to(logoSide1, { duration: 1, xPercent: 150, autoAlpha: 0 });
    gsap.to(logoSide2, { duration: 1, xPercent: -150, autoAlpha: 0 });
    gsap.to(logoSide3, { duration: 1, xPercent: 150, autoAlpha: 0 });
    gsap.to(logoSide4, { duration: 1, xPercent: -150, autoAlpha: 0 });
   }
}

// Define the pointerleave event handler
function onPointerLeave() {
   if (!svgLogo.classList.contains("active")) {
    var logo = svgLogo.querySelector("svg");
    gsap.to(logo, 1, { startAt: { rotation: 360 }, rotation: 0 });
    gsap.to(logoSide1, { duration: 1, xPercent: 0, autoAlpha: 1 });
    gsap.to(logoSide2, { duration: 1, xPercent: 0, autoAlpha: 1 });
    gsap.to(logoSide3, { duration: 1, xPercent: 0, autoAlpha: 1 });
    gsap.to(logoSide4, { duration: 1, xPercent: 0, autoAlpha: 1 });
   }
}

function init(){




  function menuHoverEffect(){
 //if( document.querySelector('main').getAttribute('data-barba-namespace') !== 'index' )

    // Later, remove the event listeners
svgLogo.removeEventListener("pointerenter", onPointerEnter);
svgLogo.removeEventListener("pointerleave", onPointerLeave);

  setTimeout(() => {
    var dataNameSpce = document.querySelector('main').getAttribute('data-barba-namespace');


    gsap.set(logoSide1,{ xPercent : 0, autoAlpha: 1});
    gsap.set(logoSide3,{ xPercent : 0, autoAlpha: 1});


    if(dataNameSpce==='index'){
        //console.log('data-namespace', '');


    } else {
        svgLogo.addEventListener("pointerenter", onPointerEnter);
        svgLogo.addEventListener("pointerleave", onPointerLeave);
        //console.log('data-namespace =>', dataNameSpce);
        // svgLogo.addEventListener("pointerenter", function(e){

        //   if( !svgLogo.classList.contains("active") && dataNameSpce!='index')
        //   {
        //     var logo = svgLogo.querySelector("svg");
        //     gsap.to(logo, 1, { startAt:{rotation:0}, rotation:360 })
        //     gsap.to(logoSide1,{ duration:1, xPercent : 150, autoAlpha: 0});
        //     gsap.to(logoSide2,{ duration:1, xPercent : -150, autoAlpha: 0});
        //   }
        // })
        // svgLogo.addEventListener("pointerleave", function(e){

        //   if( !svgLogo.classList.contains("active") && dataNameSpce!='index')
        //   {
        //     var logo = svgLogo.querySelector("svg");
        //     gsap.to(logo, 1, { startAt:{rotation:360}, rotation:0 })
        //     gsap.to(logoSide1,{ duration:1, xPercent : 0, autoAlpha: 1});
        //     gsap.to(logoSide2,{ duration:1, xPercent : 0, autoAlpha: 1});
        //   }
        // })
    }

}, "1000");





  // gsap.set(menuItems,{ scale: 0.35, autoAlpha:0 });

}


/* const loadingScreen = document.querySelector(".loading_screen");
gsap.set(loadingScreen,{ yPercent: 0, autoAlpha: 1 });
gsap.set(".loading_screen h2",{ yPercent: 100, autoAlpha:0 })
gsap.set(".loading_screen h2",{ yPercent: 100, autoAlpha:0 })

gsap.to(".loading_screen h2",{ yPercent: 0, autoAlpha:1, stagger: 0.08, duration: 0.8 })

gsap.delayedCall(0.8, function() {
  gsap.to(".loading_screen h2",{ yPercent: 0, autoAlpha:1, stagger: 0.08, duration: 0.8 })
})
gsap.delayedCall(1.8, function() {
  gsap.to(".loading_screen h2",{ yPercent: -100, autoAlpha:0, stagger: 0.08, duration: 0.5 })
})
gsap.delayedCall(2.3, function() {
  gsap.to(".loading_screen h2",{ yPercent: -100, autoAlpha:0, stagger: 0.08, duration: 0.5 })
  gsap.to(".loading_screen",{ yPercent: -100,stagger: 0.08, duration: 0.5 })
}) */



/*var tl = gsap.timeline(),
alembi = new SplitText(".loading_screen h2", { type: "words,chars" }),
chars = alembi.chars; //an array of all the divs that wrap each character
gsap.set(".loading_screen h2", { perspective: 400 });
console.log(chars);
tl.from(chars, {
  duration: 0.8,
  opacity: 0,
  //scale: 0,
  y: 80,
  //rotationX: 180,
  //transformOrigin: "0% 50% -50",
  //ease: "back",
  stagger: 0.08,
  onComplete: () => alembi.revert()
});*/



const loader = document.querySelector('.loader');
const pageTransitionElement = document.querySelector('.page-transition-effect');
gsap.set(loader,{ autoAlpha:0, yPercent:100 });
gsap.set(".loader h2",{ yPercent: 100, autoAlpha:0});
function loaderIn()
{
  gsap.set(loader, { yPercent:100, autoAlpha: 1 });
  gsap.to(loader,{ duration: 0.8,yPercent: 0});
  gsap.to(".loader h2",{ delay:0.8, yPercent: 0, autoAlpha: 1, duration: 0.8 });
  gsap.to(".loader h2",{ delay:1.8, yPercent: -100, autoAlpha: 0, duration: 0.8 });

  return gsap.to(".loader h2",{ delay:1.8, yPercent: -100, duration: 0.8 });
}

    function loaderAway() {
        // GSAP tween to hide the loading screen
        return gsap.to(loader,{ duration: 1,yPercent: -100, onComplete:function(){
          gsap.set(loader,{ autoAlpha:0, yPercent:100 });
          gsap.set(".loader h2",{ yPercent: 100, autoAlpha:0});

        }});
    }

    function loaderButtonTransition() {
        // GSAP tween to stretch the loading screen across the whole screen
        return gsap.fromTo(pageTransitionElement,
            {
               scale:0
             },
             {
               duration: 1,
               ease: "Power4.inOut",
               scale : 200,

             });
    }

    function loaderButtonTransitionOut() {
        // GSAP tween to stretch the loading screen across the whole screen
        return gsap.fromTo(pageTransitionElement,
            {
               scale:200
             },
             {
               duration: 0.001,
               ease: "Power4.inOut",
               scale : 0,

             });
    }

  barba.hooks.enter(() => {
    window.scrollTo(0, 0);
     //init();
  });
  barba.hooks.after(() => {
    Shopify.bindEvents(); // Hypothetical function to rebind Shopify events
});

  barba.hooks.afterEnter((data) => {

    var videos = document.querySelectorAll('video');
    if( videos )
    {
      videos.forEach(function(video) {
          video.play();
      });
    }
    var cartOverlay = document.querySelector(".cart-overlay");
    gsap.set(cartOverlay,{ autoAlpha:0 });
    var allFilters = document.querySelectorAll(".disclosure-has-popup");
    if( allFilters ){
      allFilters.forEach((filter) => {
          filter.classList.remove("open-accordian");
          filter.classList.add("close-accordian");
      });
    }

    var filtersTopBar = document.querySelector(".active-facets.active-facets-desktop");
    if( filtersTopBar ){
      var filtersBottomBar = document.querySelector(".active-facets.active-facets-mobile");
      if (window.matchMedia("(max-width: 767px)").matches) {
        //MOBILE


        var countActiveFilters = filtersTopBar.querySelectorAll(".active-facets__button");
        //console.log("countActiveFilters",countActiveFilters.length);
        if( countActiveFilters.length > 0 )
        {
          gsap.to(filtersTopBar,{ height:"auto", duration:1 })
          filtersTopBar.classList.add("active_mobile_filter");
        }
        else
        {
          gsap.to(filtersTopBar,{
            height:0,
            duration:1,
            onComplete:function(){
              filtersTopBar.classList.remove("active_mobile_filter");
            }
          })
        }

        var countActiveFilters = filtersBottomBar.querySelectorAll(".active-facets__button");
        //console.log("countActiveFilters",countActiveFilters.length);
        var activeSortItem = document.querySelector('.trigger_sorting_html input[name="sort_by"]:checked');
        //console.log("activeSortItem",activeSortItem);
        if (activeSortItem && activeSortItem.getAttribute("data-sort-by") == 'New to old' && countActiveFilters.length ==0  ){
          gsap.to(filtersBottomBar, {
            height:0,
            opacity:0,
            duration: 1,
            onComplete:function(){
              filtersBottomBar.classList.remove('facet-open');
              //console.log("no filter & sort selected");
            }
          });
        }
        else
        {
          //console.log("have 1 filter or sort selected");
          filtersBottomBar.classList.add('facet-open');
          gsap.to(filtersBottomBar, { height:"auto", opacity:1, duration: 1});
        }
      }
      else{
      //DESKTOP
      var countActiveFilters = filtersBottomBar.querySelectorAll(".active-facets__button");
      //console.log("countActiveFilters",countActiveFilters.length);
      var activeSortItem = document.querySelector('.trigger_sorting_html input[name="sort_by"]:checked');
      //console.log("activeSortItem",activeSortItem);

      if (activeSortItem && activeSortItem.getAttribute("data-sort-by") == 'New to old' && countActiveFilters.length ==0  ){
        gsap.to(filtersBottomBar, {
          height:0,
          opacity:0,
          duration: 1,
          onComplete:function(){
            filtersBottomBar.classList.remove('facet-open');
            //console.log("no filter & sort selected");
          }
        });
      }
      else
      {
        //console.log("have 1 filter or sort selected");
        filtersBottomBar.classList.add('facet-open');
        gsap.to(filtersBottomBar, { height:"auto", opacity:1, duration: 1});
      }


    }
    }

    if (window.matchMedia("(max-width: 767px)").matches) {
      var navItemsMobileActive = document.querySelectorAll(".circleMenuMobile ul li a");
      var currentPath = window.location.pathname;
      navItemsMobileActive.forEach(( navItem ) => {
        if (navItem.getAttribute('href') === currentPath) {
          navItem.classList.add("active-menu-item");
        }
        else{
          navItem.classList.remove("active-menu-item");
        }
      });






    }


    gsap.set(menuItems,{ scale: 0.35, autoAlpha:0 });
    var allNavItems = document.querySelectorAll(".circleMenu .list-menu li a")
    gsap.set(".circleMenu .list-menu li a span",{ yPercent: 100, autoAlpha:1 });
    allNavItems.forEach(( item, index ) => {
      //console.log(allNavItems[1]);
      if( index==1 )
      {
        gsap.set(item,{ scale: 0.51, autoAlpha:1 });
      }
      if( index==2 )
      {
        gsap.set(item,{ scale: 0.34, autoAlpha:1 });
      }

      if( index==3 )
      {
        gsap.set(item,{ scale: 0.24, autoAlpha:1 });
      }
      if( index==6 )
      {
        gsap.set(item,{ scale: 0.2, autoAlpha:1 });
      }
    })

    menuIconsFooter.forEach(( menuIconFooter ) => {

      menuIconFooter.classList.remove("active");
    })
    gsap.set(menuItemsFooter,{ scale: 0.35, autoAlpha:0 });
    var allNavItemsFooter = document.querySelectorAll(".circleMenuFooter li a")
    gsap.set(".circleMenuFooter li a span",{ yPercent: 100, autoAlpha:1 });
    allNavItemsFooter.forEach(( item, index ) => {
      if( index==1 )
      {
        gsap.set(item,{ scale: 0.51, autoAlpha:1 });
      }
      if( index==2 )
      {
        gsap.set(item,{ scale: 0.34, autoAlpha:1 });
      }

      if( index==3 )
      {
        gsap.set(item,{ scale: 0.24, autoAlpha:1 });
      }
      if( index==5 )
      {
        gsap.set(item,{ scale: 0.2, autoAlpha:1 });
      }
      if( index==6 )
      {
        gsap.set(item,{ scale: 0.14, autoAlpha:1 });
      }
    })

    menuIconsMobile.forEach(( menuIconMobile ) => {

      menuIconMobile.classList.remove("active");
    })
    document.querySelector("body").classList.remove("mobilemenuopen");
    gsap.set(menuItemsMobile,{ scale: 0, autoAlpha:0 });
    menuItemsMobile.classList.remove("fillbg");
    var allNavItemsMobile = document.querySelectorAll(".circleMenuMobile li a")
    gsap.set(".circleMenuMobile li a span",{ yPercent: 100, autoAlpha:0 });
    allNavItemsMobile.forEach(( item, index ) => {
      gsap.set(item,{ scale: 0.5, autoAlpha:0 });
    })
    //Reinitialize JavaScript after each page transition
    //const nextScripts = data.next.container.querySelectorAll("script");
    const nextScripts = data.next.container.querySelectorAll("script");

// Filter the scripts to get only those with a 'src' attribute
const scriptsWithSrc = Array.from(nextScripts).filter(script => script.hasAttribute('src'));
    // Iterate over new scripts
    scriptsWithSrc.forEach((nextScript) => {
      const src = nextScript.src;
      //Duplicate check - no need to re-execute scripts that are already loaded.
      if (document.head.querySelector('script[src="' + src + '"]') == undefined ) {
          const newScript = document.createElement("script");
          newScript.src = src;
          newScript.async = true;
          document.head.append(newScript);
          nextScript.remove(); // Cleaning up the script in the container;
      }
    });

    var nextHtml = data.next.container;
    removeModuleScripts();
    removeBannerScripts();

     // Import module scripts for the new page
    if( data.next.namespace == "collection.gallery-grid" ) {
        canvasselected();
        newgallerycanvas();
        initializeGallery();
    }
    else {
      document.documentElement.style.cursor = "initial";
      var canvases = document.querySelectorAll('canvas');
      // Loop through all canvas elements
      canvases.forEach(function(canvas) {
      var innercanvas = canvas.querySelectorAll('canvas');
      //console.log("innercanvas",innercanvas);
        // Get the WebGL context
        var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

        if (gl) {
            // Remove the existing WebGL context
            gl.getExtension('WEBGL_lose_context').loseContext();
        }
    });
    }


    //console.log("data.next.namespace",data.next.namespace);
    if( data.next.namespace == "index" ){
      //console.log("jsd");
        importBannerScripts(nextHtml);
    }

  });
  function removeModuleScripts() {
    var existingModuleScripts = document.head.querySelectorAll('script[type="module"]');
    existingModuleScripts.forEach(function(script) {
        script.parentNode.removeChild(script);
    });
  }
  function removeBannerScripts() {
    var existingModuleScripts = document.head.querySelectorAll('script.banner');
    if( existingModuleScripts )
    {
      existingModuleScripts.forEach(function(script) {
          script.parentNode.removeChild(script);
      });
    }
  }
  function importBannerScripts(container) {


    // Standard script loading approach - jQuery
    var jqueryScriptUrl = "https://code.jquery.com/jquery-3.6.0.min.js";
    var clonedScript = document.createElement('script');
    clonedScript.classList = 'banner';

    var timestamp = new Date().getTime();
    var scriptUrl = jqueryScriptUrl + '?t=' + timestamp;
    clonedScript.src = scriptUrl;
    clonedScript.onload = function() {
        //console.log('Module script loaded:', clonedScript.src);
    };
    // Listen for errors
    clonedScript.onerror = function() {
        console.error('Error loading module script:', clonedScript.src);
    };
    //console.log("clonedScript",clonedScript);
    document.head.appendChild(clonedScript);


  gsap.delayedCall(0.5, function() {
    // Standard script loading approach - Slick Carousel
    var slickScriptUrl = "https://cdn.jsdelivr.net/npm/slick-carousel/slick/slick.min.js";
    var clonedScript = document.createElement('script');
    clonedScript.classList = 'banner';

    var timestamp = new Date().getTime();
    var scriptUrl = slickScriptUrl + '?t=' + timestamp;
    clonedScript.src = scriptUrl;
    clonedScript.onload = function() {
        //console.log('Module script loaded:', clonedScript.src);
    };
    // Listen for errors
    clonedScript.onerror = function() {
        console.error('Error loading module script:', clonedScript.src);
    };
    //console.log("clonedScript",clonedScript);
    document.head.appendChild(clonedScript);
     gsap.delayedCall(0.5, function() {
        productLinkHoverImage( container );
     })
  })


  }

  // Function to import module scripts for the new page
  function importModuleScripts(container) {

    // Standard script loading approach - Grid Gallery
    const gridGalleryScriptUrl = "/assets/grid-gallery.js";
    var clonedScript = document.createElement('script');
    clonedScript.type = 'module';

    var timestamp = new Date().getTime();
    var scriptUrl = gridGalleryScriptUrl + '?t=' + timestamp;
    clonedScript.src = scriptUrl;
    clonedScript.onload = function() {
        //console.log('Module script loaded:', clonedScript.src);
    };

    // Listen for errors
    clonedScript.onerror = function() {
        console.error('Error loading module script:', clonedScript.src);
    };
    //console.log("clonedScript",clonedScript);
    document.head.appendChild(clonedScript);
  }

   barba.init({
      sync: true,
        transitions: [
          {
              name: 'back',
              priority: 1,
              custom: ({ trigger }) => {return trigger === 'back'},
              enter() {
                  //console.log('back enter')
              },
          },
          {
            name: 'forward',
            priority: 1,
            custom: ({ trigger }) => {return trigger === 'forward'},
            enter() {
                //console.log('forward enter')
            },
          },
          {
            async leave(data) {

               //const cartDrawers = data.current.container.querySelectorAll('cart-drawer');
               //cartDrawers.forEach(cartDrawer => cartDrawer.cleanup());
              var trigger = data.trigger;
              var btnPageTransitions = trigger.classList.contains('btn-page-transitions');
              if(btnPageTransitions){
                var rect = trigger.getBoundingClientRect();
                pageTransitionElement.style.top = (rect.top + 54)+'px';
                pageTransitionElement.style.left = (rect.left + 54)+'px';

                await loaderButtonTransition();
              } else {
                 await loaderIn();
              }

              progressBarShow();
            },
            once(data) {
             menuHoverEffect();


              if (data.next.container.classList.contains('gimme-products')) {
                //cmt document.body.classList.add('color-background-2');
              } else {
                //cmt document.body.classList.remove('color-background-2');
              }

            document.querySelector("body").setAttribute('id',data.next.namespace.replace(".", "-"));
            },
            enter(data) {


                menuHoverEffect();
                var logo = svgLogo.querySelector("svg");
               // gsap.set(logo, { startAt: { rotation: 360 }, rotation: 0 });
                gsap.set(logoSide1, { xPercent: 0, autoAlpha: 1 });
                gsap.set(logoSide2, { xPercent: 0, autoAlpha: 1 });
              gsap.set(logoSide3, { xPercent: 0, autoAlpha: 1 });
                gsap.set(logoSide4, { xPercent: 0, autoAlpha: 1 });
                document.querySelector("body").setAttribute('id',data.next.namespace.replace(".", "-"));

                loaderAway();
                loaderButtonTransitionOut();
                // Initialize or reinitialize scripts safely
                if (window.SearchForm) {
                  new window.SearchForm();
                }

            },
        //  beforeEnter(data) {
        //     loadScriptOnce('https://parxdesign.com/cdn/shop/t/6/assets/details-disclosure.js?v=128259942835388175331713548948', 'dynamic');
        // },
           afterLeave({ current, next }) {
             gsap.set(menuItems,{ scale: 0.35, autoAlpha:0 });
              menuIcons.forEach(( menuIconClass ) => {
              menuIconClass.classList.remove("active");
            })
    if (next.container) {

      if (next.container.classList.contains('gimme-products')) {
        //cmt document.body.classList.add('color-background-2');
      } else {
        //cmt document.body.classList.remove('color-background-2');
      }

    //      const currentScripts = current.container.querySelectorAll("script");
    // currentScripts.forEach(script => {
    //     if (script.classList.contains('dynamic')) { // Assume dynamically added scripts are tagged with 'dynamic'
    //         script.remove();
    //     }
    // });

  /*      const nextScripts = next.container.querySelectorAll("script");

        // Iterate over new scripts
        nextScripts.forEach((nextScript) => {
            const src = nextScript.src;
            // Check both head and body for the script
            if (!document.querySelector(`script[src="${src}"]`)) {
                console.log("Adding new script because it wasn't found:", src);
                const newScript = document.createElement("script");
                newScript.src = src;
                newScript.async = true;
                //document.head.append(newScript);
            } else {
                console.log("Script already loaded, no need to add again:", src);
            }
            nextScript.remove(); // Always remove the script from the next container
        });
   */
    }
}

        }],
       views: [
        {
          namespace: 'index',
          afterEnter(data) {
            homePage(data.current.container, data.next.container, 'index');
          }
        },
        {
          namespace: 'collection',
          afterEnter(data) {
            collectionPage(data.current.container, data.next.container,'collection');
          }
        },
         {
          namespace: 'collection.gallery-collection',
          afterEnter(data) {
            galleryCollectionPage(data.current.container, data.next.container,'collection');
          }
        },
        {
          namespace: 'collection.gallery-grid',
          afterEnter(data) {
            collectionGalleryGrid(data.current.container, data.next.container,'collection');
          }
        },
        {
          namespace: 'page.about',
          afterEnter(data) {
            aboutPage(data.current.container, data.next.container,'page.about');
          }
        },
        {
          namespace: 'product',
          afterEnter(data) {
            productPage(data.current.container, data.next.container,'product');
          }
        },
        {
          namespace: 'page.contact',
          afterEnter(data) {
            contactPage(data.current.container, data.next.container,'page.contact');
          }
        },
        {
          namespace: 'page.faq',
          afterEnter(data) {
            faqPage(data.current.container, data.next.container,'page.faq');
          }
        },


      ]
    })

}
window.addEventListener('load', function(){
    init();
    // Scripts.init();
    // createTextCircle.init('.circle-add-to-cart');

});

function loadScriptOnce(src, className) {
    if (!document.querySelector('.'+className)) {
        const script = document.createElement('script');
        script.src = src;
        script.classList.add(className);
        script.defer = true;
        document.head.appendChild(script);
    }
}

/*
const loader = document.querySelector('.loader');
gsap.set(loader, {xPercent:-100, opacity:0 });

function loaderIn() {
  // GSAP tween to stretch the loading screen across the whole screen
  return gsap.to(loader,{ duration: 0.8,xPercent: 0, opacity:1});
}

function loaderAway() {
  // GSAP tween to hide the loading screen
  return gsap.to(loader,{ duration: 0.8,xPercent: -100, opacity:0});
}
barba.init({
  cacheFirstPage: true,
  sync: true,
    transitions: [{
      async leave() {
        await loaderIn();
      },
      enter() {
          loaderAway();
      }
    }],
  views: [
    {
      namespace: 'index',
      afterEnter(data) {
        homePage(data.current.container, data.next.container, 'index');
      }
    },
    {
      namespace: 'collection',
      afterEnter(data) {
        collectionPage(data.current.container, data.next.container,'collection');
      }
    },
    {
      namespace: 'page.about',
      afterEnter(data) {
        aboutPage(data.current.container, data.next.container,'page.about');
      }
    },
    {
      namespace: 'product',
      afterEnter(data) {
        productPage(data.current.container, data.next.container,'product');
      }
    },
    {
      namespace: 'page.contact',
      afterEnter(data) {
        contactPage(data.current.container, data.next.container,'page.contact');
      }
    },
    {
      namespace: 'page.faq',
      afterEnter(data) {
        faqPage(data.current.container, data.next.container,'page.faq');
      }
    },
  ]
});
barba.hooks.beforeEnter(() => {
  killEvents();
});
barba.hooks.enter(() => {
  window.scrollTo(0, 0);
})
barba.hooks.afterEnter(() => {
  addEvents();
});
*/

function homePage(currentHtml, nextHtml, handle) {
      var bigBtns = nextHtml.querySelectorAll(".col2a, .col2b");

  function initScrollTrigger(element) {
    if( bigBtns )
    {
      bigBtns.forEach(( bigBtn ) => {
          gsap.from(bigBtn, {
              scrollTrigger: {
                  start: 'top 70%',
                  trigger: bigBtn,
                  onEnter() {
                      bigBtn.classList.add('animate_gallery_grid');
                      setTimeout(() => {
                          bigBtn.classList.remove('animate_gallery_grid');
                      }, 1500);
                  },
                  onEnterBack() {
                      bigBtn.classList.add('animate_gallery_grid');
                      setTimeout(() => {
                          bigBtn.classList.remove('animate_gallery_grid');
                      }, 1500);
                  },
                  //once: true,
              }
          });
      })
    }
    //console.log("Initializing ScrollTrigger for:", element);
  }

  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  if (bigBtns) {
    gsap.delayedCall(2.6, function() { initScrollTrigger(bigBtns); });
  } else {
    console.error("tabElement not found.");
  }



  // var clickArrow = nextHtml.querySelector(".scrollIcon");
  // clickArrow.addEventListener("click", function(e){
  //   document.querySelector('.banner-with-products').scrollIntoView({ behavior: 'smooth', block: 'end' });
  // })




  //Header Menu
 // headerMenu( nextHtml, handle );
  // IMAGE BANNER WITH PRODUCTS


  //IMAGE BLOG ZOOM IN ZOOM OUT
  revealImages( nextHtml );
  // Product Card
  productCardThumbnails( nextHtml );
  // MARQUEE
  cardMarquee( nextHtml );
}
function collectionGalleryGrid(currentHtml, nextHtml, handle) {
  //console.log("I m on gallery grid");
  var moveImagesUpDown = nextHtml.querySelectorAll(".gallery-coming-soon .col");
    moveImagesUpDown.forEach(( moveImageUpDown ) => {
        var rev = ( moveImageUpDown.classList.contains("up") ) ? true : false;
        var rotateEle = moveImageUpDown.querySelectorAll("img");
        let moveImageUpDown_obj = verticalLoop(rotateEle, {
            repeat: -1,
            paused: false,
            center: true,
            draggable: false, // I'm just being fancy
            inertia: true,
            reversed:rev,// even fancier
            speed:0.3,
        });
    })
}

function galleryCollectionPage(currentHtml, nextHtml, handle) {

    var productGrid = nextHtml.querySelector(".product-grid-gallery .product-grid");
  if( productGrid )
  {
  imagesLoaded(productGrid, function() {
    //console.log("hh");
    var iso = new Isotope(productGrid, {
      itemSelector: 'li',
      layoutMode: 'masonry'
    });
  });
    // console.log("productGrid",productGrid);
    // var iso = new Isotope(productGrid, {
    //   itemSelector: 'li',
    //   layoutMode: 'masonry'
    // });
    // var imgLoad = imagesLoaded(".product-grid");
    // if( imgLoad )
    // {
    //   iso.layout();

    // }
    // imgLoad.on('progress', function(instance, image) {
    //   // Layout Isotope after each image loads

    //   console.log('image', image);
    //   iso.layout();
    // });
  }

  //console.log(currentHtml, nextHtml);

  //Header Menu
  // headerMenu(nextHtml, handle);
  // Product Card
  productCardThumbnails( nextHtml );
  // MARQUEE
  cardMarquee( nextHtml );

  var trigger_sorting = nextHtml.querySelector(".trigger_sorting");
  var trigger_sorting_html = nextHtml.querySelector(".trigger_sorting_html");
  gsap.set(trigger_sorting_html,{ height:0 });
  trigger_sorting.addEventListener("click", function(e){
    if( trigger_sorting.classList.contains("active") )
    {
      trigger_sorting.classList.remove("active")
      gsap.to(trigger_sorting_html,{ height:0, duration: 1 });
    }
    else
    {
      trigger_sorting.classList.add("active")
      gsap.to(trigger_sorting_html,{ height:"auto", duration: 1 });
    }
  })

   var trigger_filters = nextHtml.querySelector(".trigger_filters");
  if( trigger_filters )
  {
    var shopFiltersElement = nextHtml.querySelector(".shop-filters");

    var trigger_filter_close = nextHtml.querySelector(".trigger_filter_close");

    trigger_filters.addEventListener("click", function(e){
      //shopFiltersElement.style.display = 'block';
      gsap.to(shopFiltersElement, { xPercent: -100, duration: 1 });
    })
    trigger_filter_close.addEventListener("click", function(e){
      // shopFiltersElement.style.display = 'none';
      gsap.to(shopFiltersElement, { xPercent: 0, duration: 1 });
      if (window.matchMedia("(max-width: 767px)").matches) {
        //console.log("inn kk")
        var allFilters = nextHtml.querySelectorAll("summary.facets__summary");
        allFilters.forEach(( filter ) => {
          filter.classList.add("close-summary");
          filter.querySelector(".parent-display").classList.add("close-details")
        });
      }
      //console.log("Out")
    })
  }






  openCartDrawer( nextHtml );

}
// Barba.Pjax.start();

//         // Listen for popstate event
//         window.addEventListener('popstate', function(event) {
//             // Trigger Barba.js popstate event handler
//             Barba.Dispatcher.onPopState(event);
//         });
function collectionPage(currentHtml, nextHtml, handle) {
  let matchMedia = gsap.matchMedia();
  matchMedia.add("(max-width: 767px)", () => {
      gsap.delayedCall(2.6, function() {
      var bigBtns = nextHtml.querySelectorAll(".col2a, .col2b");
      bigBtns.forEach(( bigBtn ) => {
          gsap.from(bigBtn, {
              scrollTrigger: {
                  start: 'top 70%',

                  trigger: bigBtn,
                  onEnter() {
                      bigBtn.classList.add('animate_gallery_grid');
                      setTimeout(() => {
                          bigBtn.classList.remove('animate_gallery_grid');
                      }, 1500);
                  },
                  onEnterBack() {
                      bigBtn.classList.add('animate_gallery_grid');
                      setTimeout(() => {
                          bigBtn.classList.remove('animate_gallery_grid');
                      }, 1500);
                  },
                  //once: true,
              }
          });
      })
      })
  })
  matchMedia.add("(min-width: 768px)", () => {
      gsap.delayedCall(2.6, function() {
      var bigBtns = nextHtml.querySelectorAll(".col2a, .col2b");
      bigBtns.forEach(( bigBtn ) => {
          gsap.from(bigBtn, {
              scrollTrigger: {
                  start: 'top 70%',
                  trigger: bigBtn,
                  onEnter() {
                      bigBtn.classList.add('animate_gallery_grid');
                      setTimeout(() => {
                          bigBtn.classList.remove('animate_gallery_grid');
                      }, 1500);
                  },
                  onEnterBack() {
                      bigBtn.classList.add('animate_gallery_grid');
                      setTimeout(() => {
                          bigBtn.classList.remove('animate_gallery_grid');
                      }, 1500);
                  },
                  //once: true,
              }
          });
      })
      })
  })

  var getSearchParam = new URLSearchParams(window.location.search);
  var gimmePromotion = getSearchParam.get('filter.p.m.custom.gimme_promotion');
  var gimmeCollection = getSearchParam.get('filter.p.m.custom.product_collections');


    if(gimmePromotion || gimmeCollection == 'gid://shopify/Metaobject/83235078320'){
      nextHtml.classList.add('gimme-products');
      //cmt document.body.classList.add('color-background-2');
    } else {
      nextHtml.classList.remove('gimme-products');
      //cmt document.body.classList.remove('color-background-2');
    }


  //Header Menu
  // headerMenu(nextHtml, handle);
  // Product Card
  productCardThumbnails( nextHtml );
  // MARQUEE
  cardMarquee( nextHtml );

  var trigger_sorting = nextHtml.querySelector(".trigger_sorting");
  var trigger_sorting_html = nextHtml.querySelector(".trigger_sorting_html");
  gsap.set(trigger_sorting_html,{ height:0 });
  trigger_sorting.addEventListener("click", function(e){
    if( trigger_sorting.classList.contains("active") )
    {
      trigger_sorting.classList.remove("active")
      gsap.to(trigger_sorting_html,{ height:0, duration: 1 });
      nextHtml.querySelector(".doneWrap").style.display = 'none';
    }
    else
    {
      trigger_sorting.classList.add("active")
      gsap.to(trigger_sorting_html,{ height:"auto", duration: 1 });
      nextHtml.querySelector(".doneWrap").style.display = 'block';
    }
  })

   var trigger_filters = document.querySelector(".trigger_filters");
  if( trigger_filters ){
  var shopFiltersElement = document.querySelector(".shop-filters");

  var trigger_filter_close = document.querySelector(".trigger_filter_close");


  trigger_filters.addEventListener("click", function(e){
    //shopFiltersElement.style.display = 'block';
    gsap.to(shopFiltersElement, { xPercent: -100, duration: 1 });
    // if (window.matchMedia("(max-width: 767px)").matches) {
    //   console.log("inn jamal")
    //   var allFilters = document.querySelectorAll(".disclosure-has-popup");
    //   allFilters.forEach(( filter ) => {
    //     filter.classList.add("close-accordian");
    //     var filterHeading = filter.querySelector("summary.facets__summary");
    //     filterHeading.addEventListener("click", function(e){
    //       if( filter.classList.contains("close-accordian") )
    //       {
    //         filter.classList.remove("close-accordian");
    //         filter.classList.add("open-accordian");
    //       }
    //       else{
    //         filter.classList.add("close-accordian");
    //         filter.classList.remove("open-accordian");
    //       }
    //     })
    //   });
    // }
    //console.log("Out")
  })


  trigger_filter_close.addEventListener("click", function(e){
    // shopFiltersElement.style.display = 'none';
    gsap.to(shopFiltersElement, { xPercent: 0, duration: 1 });

  })
  }






  openCartDrawer( nextHtml );

}
function aboutPage(currentHtml, nextHtml, handle) {

  var targetI = nextHtml.querySelector(".about-grid .desc p");
  const childSplit = new SplitText(targetI, {
    type: "lines,chars",
    linesClass: "split-lines",
    charsClass: "split-char"
  });
  gsap.set('.split-char',{ autoAlpha:0.5 });

  //console.log("childSplit.lines",childSplit.lines);

  childSplit.lines.forEach((lineTop) => {
    let triggerChild = gsap.timeline({
      scrollTrigger: {
        trigger: lineTop,
        start: "top 75%",
        end: "top bottom",
        toggleActions: "play none reverse reverse",
        scrub: 0.5 // Make sure scrub is used in scrollTrigger configuration
      }
    });
    triggerChild.to(lineTop.querySelectorAll(".split-char"), {
      autoAlpha: 1,
      duration: 0.05,
      ease: 'none',
      stagger: 0.05 // Add stagger for sequential animation
    });
  });

  revealImages( nextHtml );
  openCartDrawer( nextHtml );




}
function contactPage(currentHtml, nextHtml, handle) {
  //Header Menu
  //console.log("gg");
  // headerMenu(nextHtml, handle);
  //openCartDrawer( nextHtml );

  var bgVideoTag = nextHtml.querySelector('.bgVideo video');
  //console.log("bgVideoTag",bgVideoTag);
  if( bgVideoTag )
  {
    bgVideoTag.play();
  }



  var emailMarquees = nextHtml.querySelectorAll(".email_marquee_part");
  emailMarquees.forEach(( email ) => {
    const loop = horizontalLoop(email, {
      repeat: -1,
      paused: false,
    });
  });
  var clickedElements = nextHtml.querySelectorAll('.email_marquee_inner, .clicktocopy');
  var clickTextChangeEle = nextHtml.querySelector(".clicktocopy");
  var clickText1 = clickTextChangeEle.querySelector(".clickText");
  var clickText2 = clickTextChangeEle.querySelector(".copiedText");
  gsap.set(clickText2,{ yPercent:100 })
  gsap.set(clickText1,{ yPercent:0 })

  clickedElements.forEach(( clickedElement ) => {
    clickedElement.addEventListener('click', function() {
      var textToCopy = clickedElement.getAttribute('email');
      var textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      // Clean up - remove the textarea
      document.body.removeChild(textarea);
      // Optionally, provide user feedback or other actions after copying
      // clickTextChangeEle.innerHTML = 'copied to clipboard';
      // console.log('Text copied to clipboard');
      gsap.to(clickText1,{ yPercent:-100, duration:1, ease:"NONE" });
      gsap.to(clickText2,{ yPercent:0, duration:1, ease:"NONE" });
    });
  })


  var contactForm = nextHtml.querySelector('#ContactForm');

  var contactButton = nextHtml.querySelector(".contact__button button");

  contactButton.addEventListener('click', function(event) {
    event.preventDefault();
    let firstname = nextHtml.querySelector('#ContactForm-firstname').value;
    let lastname = nextHtml.querySelector('#ContactForm-lastname').value;
    if (firstname.trim() === '' || lastname.trim() === '' ) {
        alert('Please fill in all fields.');
        return;
    }
    // If form is valid, submit using Fetch API
    submitForm(firstname, lastname);
    return false;
  });
  function submitForm(firstname, lastname) {
    fetch('/contact', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            contact: {
                firstname: firstname,
                lastname: lastname,
            }
        })
    }).then(response => {
        if (response.ok) {
            alert('Message sent successfully!');
            nextHtml.querySelector('#ContactForm').reset();
        } else {
            throw new Error('Failed to send message.');
        }
    })
    .catch(error => {
        console.error('Error:', error);
        alert('An error occurred. Please try again later.');
    });
  }
}
function faqPage(currentHtml, nextHtml, handle) {
  //Header Menu
 // headerMenu(nextHtml, handle);
  openCartDrawer( nextHtml );
}
function productPage(currentHtml, nextHtml, handle) {
  const body = document.querySelector("body");
      body.classList.remove('non-stciky');



  function initScrollTrigger(element) {
    if (tabElement) {


      ScrollTrigger.create({
        trigger: tabElement,
        //markers: true,
        start: "top 99%",
        end: "bottom 0%",
        toggleActions: "play none none none",
        onEnter: () => {
          //console.log("Entering...");
          body.classList.add('non-stciky');
        },
        onLeaveBack: () => {
          //console.log("Leaving back...");
          body.classList.remove('non-stciky');
        }
      });

      // Call the initialization function
      //gsap.delayedCall(2.6, function() { initScrollTrigger(tabElement); });
    } else {
      console.error("tabElement not found.");
    }
    var bigBtns = nextHtml.querySelectorAll(".col2b");
    if( bigBtns )
    {
      bigBtns.forEach(( bigBtn ) => {
          gsap.from(bigBtn, {
              scrollTrigger: {
                  start: 'top 70%',
                  trigger: bigBtn,
                  onEnter() {
                      bigBtn.classList.add('animate_gallery_grid');
                      setTimeout(() => {
                          bigBtn.classList.remove('animate_gallery_grid');
                      }, 1500);
                  },
                  onEnterBack() {
                      bigBtn.classList.add('animate_gallery_grid');
                      setTimeout(() => {
                          bigBtn.classList.remove('animate_gallery_grid');
                      }, 1500);
                  },
                  //once: true,
              }
          });
      })
    }
    // Your custom initialization logic here
    //console.log("Initializing ScrollTrigger for:", element);
  }

  // Kill all existing ScrollTriggers
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  // Get the nextHtml element and find the tabElement within it
  var tabElement = nextHtml ? nextHtml.querySelector(".product_tabs") : null;
  //console.log("tabElement", tabElement);

  if (tabElement) {
    gsap.delayedCall(2.6, function() { initScrollTrigger(tabElement); });
  } else {
    console.error("tabElement not found.");
  }



  //Header Menu
  // headerMenu(nextHtml, handle);
  var activeTab = nextHtml.querySelector(".tab_content_full.active");
  //gsap.set(activeTab,{ height : "auto" })
  var notActiveTabs = nextHtml.querySelectorAll(".tab_content_full.notactive");
  notActiveTabs.forEach(( notActiveTab ) => {
    //gsap.set(notActiveTab,{ height:0 })
  })

  const firstListItem = nextHtml.querySelector('.thumbnails img:first-child');
  firstListItem.classList.add("active");
  const mm = gsap.matchMedia();
  const triggerThumbnailsListeners = []; // Array to store event listener references

  mm.add("(min-width: 768px)", () => {
      const triggerThumbnails = document.querySelectorAll(".triggerThumbnail");
      triggerThumbnails.forEach((triggerThumbnail) => {
          const listener = function(e) {
              const imageId = triggerThumbnail.getAttribute("imageclass");
              const triggerClass = 'media_' + imageId;

              const targetLi = document.querySelector("." + triggerClass);
              if (!triggerThumbnail.classList.contains("active")) {
                  triggerThumbnails.forEach((triggerThumbnailC) => {
                      triggerThumbnailC.classList.remove("active");
                  });
                  triggerThumbnail.classList.add("active");
                  targetLi.scrollIntoView({ behavior: 'smooth' });
              }
          };
          triggerThumbnail.addEventListener("click", listener);
          triggerThumbnailsListeners.push({ element: triggerThumbnail, listener }); // Store the listener reference
      });

      // Return a cleanup function
      return () => {
          triggerThumbnailsListeners.forEach(({ element, listener }) => {
              element.removeEventListener("click", listener); // Remove the event listener
          });
          triggerThumbnailsListeners.length = 0; // Clear the array
      };
  });

  mm.add("(max-width: 767px)", () => {
      // gsap.registerPlugin(Draggable, InertiaPlugin);
      // const slidesContainer = nextHtml.querySelector("ul.product__media-list");
      // const slides = gsap.utils.toArray(nextHtml.querySelectorAll("li.grid__item"));
      // console.log("slides",slides);
      // const snapPoints = slides.map((_, i) => -(window.innerWidth * i));
      // let direction;
      // let currentSlide = 0;

      // Draggable.create(slidesContainer, {
      //   type: "x",
      //   bounds: {
      //     minX: snapPoints[slides.length - 1],
      //     maxX: 0
      //   },
      //   onDrag: function () {
      //     direction = this.deltaX;
      //   },
      //   inertia: true,
      //   snap: {
      //     x: function (v) {
      //       console.log("creating snap points", Date.now(), v);
      //       if (direction < 0 && currentSlide < slides.length - 1) {
      //         currentSlide++;
      //       } else if (direction > -1 && currentSlide > 0) {
      //         currentSlide--;
      //       }
      //       return snapPoints[currentSlide];
      //     }
      //   }
      // });
      //console.clear();

      gsap.registerPlugin(Draggable);

      const slidesContainer = nextHtml.querySelector("ul.product__media-list");
      const slides = gsap.utils.toArray(slidesContainer.querySelectorAll("li.grid__item"));
      const snapPoints = slides.map((_, i) => -(window.innerWidth * i));
      console.log("snapPoints",snapPoints.length);
      let currentSlide = 0;
      // Function to snap to a specific index
      function snapToIndex(index) {
        currentSlide = index;
        gsap.to(slidesContainer, {
          x: snapPoints[currentSlide],
          duration: 0.5,
          ease: "power2.out"
        });
      }
  var ttSlide = snapPoints.length;
    var totalSlideSwiper = nextHtml.querySelector(".totalSlideSwiper");
    totalSlideSwiper.innerHTML = ttSlide; //.toString().padStart(2, '0');
    var currentSlideSwiper = nextHtml.querySelector(".currentSlideSwiper");
              currentSlideSwiper.innerHTML = "1";


      // Create Draggable instance
      const draggable = Draggable.create(slidesContainer, {
        type: "x",
        bounds: {
          minX: snapPoints[slides.length - 1],
          maxX: 0
        },
        onDragStart: function () {
          // No need to store startDragX, it's handled internally by Draggable
        },
        onDragEnd: function () {
          const endDragX = this.x;
          const dragDistance = snapPoints[currentSlide] - endDragX;

          // Define a threshold as 25% of the window width
          const threshold = window.innerWidth * 0.25;

          var upcomingSlide = currentSlide;

          if (dragDistance > threshold && currentSlide < slides.length - 1) {
            // Snap to next slide
            snapToIndex(currentSlide + 1);
          } else if (dragDistance < -threshold && currentSlide > 0) {
            // Snap to previous slide
            snapToIndex(currentSlide - 1);
          } else {
            // Snap back to current slide
            snapToIndex(currentSlide);
          }
          console.log("upcomingSlide",currentSlide);
          var ccSlkide = currentSlide + 1;
          currentSlideSwiper.innerHTML = ccSlkide; //.toString().padStart(2, '0');



          const triggerThumbnails = document.querySelectorAll(".triggerThumbnail");
          triggerThumbnails.forEach((triggerThumbnailC) => {
              triggerThumbnailC.classList.remove("active");
          });
          triggerThumbnails[currentSlide].classList.add("active");
        }
      });
      const triggerThumbnails = document.querySelectorAll(".triggerThumbnail");
      triggerThumbnails.forEach((triggerThumbnail) => {
          const listener = function(e) {
              const imageId = triggerThumbnail.getAttribute("imageclass");
              const triggerClass = 'media_' + imageId;

              const targetLi = document.querySelector("." + triggerClass);
              if (!triggerThumbnail.classList.contains("active")) {
                  triggerThumbnails.forEach((triggerThumbnailC) => {
                      triggerThumbnailC.classList.remove("active");
                  });
                  triggerThumbnail.classList.add("active");
                  const targetIndex = Array.from(targetLi.parentNode.children).indexOf(targetLi);
                  //console.log("Index of targetLi:", targetIndex);
                  snapToIndex(targetIndex);

                  //targetLi.scrollIntoView({ behavior: 'smooth' });
              }
          };
          triggerThumbnail.addEventListener("click", listener);
          triggerThumbnailsListeners.push({ element: triggerThumbnail, listener }); // Store the listener reference
      });

      // Return a cleanup function
      return () => {
          triggerThumbnailsListeners.forEach(({ element, listener }) => {
              element.removeEventListener("click", listener); // Remove the event listener
          });
          triggerThumbnailsListeners.length = 0; // Clear the array
      };
      // Event listener for button click
      // document.getElementById("snapButton").addEventListener("click", function() {
      //   // Call the snapToIndex function with the desired index
      //   snapToIndex(2); // Replace 2 with the desired slide index
      // });
      /*const snapPoints = slides.map((_, i) => -(window.innerWidth * i));
      let currentSlide = 0;
      let startDragX = 0;
      let endDragX = 0;

      Draggable.create(slidesContainer, {
        type: "x",
        bounds: {
          minX: snapPoints[slides.length - 1],
          maxX: 0
        },
        onDragStart: function () {
          startDragX = this.x;
        },
        onDragEnd: function () {
          endDragX = this.x;
          const dragDistance = startDragX - endDragX;

          if (dragDistance > 0 && currentSlide < slides.length - 1) {
            currentSlide++;
          } else if (dragDistance < 0 && currentSlide > 0) {
            currentSlide--;
          }

          gsap.to(slidesContainer, {
            x: snapPoints[currentSlide],
            duration: 0.5,
            ease: "power2.out"
          });
        }
      });*/


    });



  var tabLinks = nextHtml.querySelectorAll(".tabs_links_all .trigger_tab");
  const allLines = [];
  tabLinks.forEach(( tabLink,index ) => {

    var targetContent = nextHtml.querySelector( ".tab_content_"+tabLink.getAttribute("tabindex") );
    var targetI = targetContent.querySelectorAll("h2, .desc p");
    const childSplit = new SplitText(targetI, {
      type: "lines",
      linesClass: "split-child"
    });
    const parentSplit = new SplitText(targetI, {
       type: "lines",
      linesClass: "split-parent"
    });
    if( index == 0 )
    {
      gsap.set(childSplit.lines,{ yPercent:0 })
    }
    else{
      gsap.set(childSplit.lines,{ yPercent:100 })
    }
    allLines.push(childSplit.lines);
    tabLink.addEventListener("click", function(e){
      if( !tabLink.classList.contains("active") )
      {
        var ActiveIndex = nextHtml.querySelector( ".tabs_link.active" ).getAttribute("tabindex");
        var TargetIndex = tabLink.getAttribute("tabindex");

        tabLinks.forEach(( tabLinkClass ) => {
          tabLinkClass.classList.remove("active");
        })
        tabLink.classList.add("active");
        var activeContent = nextHtml.querySelector( ".tab_content_full.active" );
        //console.log("ActiveIndex",ActiveIndex);

        gsap.to(allLines[ActiveIndex], {
          duration: 0.7,
          yPercent: -100,
          ease: "none",
          //stagger: 0.1
        });
        gsap.set(allLines[ActiveIndex], { delay:0.7, yPercent: 100 })
        gsap.to(allLines[TargetIndex], {
          delay:0.3,
          duration: 0.7,
          yPercent: 0,
          ease: "none",
          //stagger: 0.1
        });



        activeContent.classList.remove("active");
        //gsap.to(activeContent,{ height : 0, duration: 1 })

        // gsap.from(childSplit.lines, {
        //   duration: 1.5,
        //   yPercent: 100,
        //   ease: "power4",
        //   stagger: 0.1
        // });

        //console.log("TargetIndex",TargetIndex);




        var targetContent = nextHtml.querySelector( ".tab_content_"+tabLink.getAttribute("tabindex") );
        targetContent.classList.add("active");
        //gsap.to(targetContent,{ height : "auto", duration: 1 })

      }
    })
  })
  //console.log("allLines",allLines);

  // MARQUEE
  cardMarquee( nextHtml );

  // Product Card
  productCardThumbnails( nextHtml );
  //openCartDrawer( nextHtml );
  var copyButton = nextHtml.querySelector('.product__info-wrapper .copy-link ');

  var shareDialog = nextHtml.querySelector(".product__info-wrapper .share-dialog");
  //gsap.set(shareDialog,{ opacity : 0 });
  var shareButton = nextHtml.querySelector(".product__info-wrapper .share-button");
  /*shareButton.addEventListener("click", function(e){
    if( shareButton.classList.contains("active") )
    {
      shareButton.classList.remove("active");
      shareDialog.classList.remove("active");
      //gsap.to(shareDialog,{ opacity : 0, duration: 1});
    }
    else
    {
      copyButton.innerHTML = "Copy link";
      shareDialog.classList.add("active");
      shareButton.classList.add("active")
      //gsap.to(shareDialog,{ opacity : 1, duration: 1});
    }
  })
  var closeButton = nextHtml.querySelector(".product__info-wrapper .close-button");
  closeButton.addEventListener("click", function(e){
    shareButton.classList.remove("active");
    shareDialog.classList.remove("active");
    //gsap.to(shareDialog,{ opacity : 0, duration: 1});
  })*/
  var shareCopyText = nextHtml.querySelector(".share-copy-text");
  gsap.set(shareCopyText,{ yPercent: 100, autoAlpha:0 });
  var textToCopy = nextHtml.querySelector('.product__info-wrapper .pen-url');
  shareButton.addEventListener("click", function(e){
      navigator.clipboard.writeText(textToCopy.textContent).then(function () {
          //SLIDEDOWN
          gsap.to(shareCopyText,{ yPercent: 0, autoAlpha:1 })
      }).catch(function (err) {
      });
  })


}

function openCartDrawer( nextHtml )
{
  var carBtn = nextHtml.querySelector(".logoSide2");
  carBtn.addEventListener("click", function(e){
    //console.log("CLICK");
    //Shopify.theme.cartDrawer.open();
    // document.dispatchEvent(new CustomEvent("cart:refresh:opend"));
  })
}
function headerMenu( nextHtml, handle )
{

  // const nextScripts = document.querySelectorAll(".cardrawerJs");
  // nextScripts.forEach((nextScript) => {
  //     const src = nextScript.getAttribute("cartdrawer");

  //     if ( nextHtml.querySelector('script[src="' + src + '"]') ==undefined )
  //     {
  //       console.log(src);
  //       const newScript = document.createElement("script");
  //       newScript.src = src;
  //       newScript.async = true;
  //       nextHtml.append(newScript);
  //     }
  //       //nextScript.remove(); // Cleaning up the script in the container;

  // });




  var menuIcons = document.querySelectorAll("a.openMenu");
  var menuItems = document.querySelector(".circleMenu");
  gsap.set(menuItems,{ scale: 0.35, autoAlpha:0 });
  menuIcons.forEach(( menuIcon ) => {
    menuIcon.addEventListener("click", function(e){
      if( menuIcon.classList.contains("active") )
      {
        menuIcons.forEach(( menuIconClass ) => {
          menuIconClass.classList.remove("active");
        })
        gsap.to(menuItems,{ scale: 0.35, autoAlpha:0, duration:1 });
      }
      else
      {
        menuIcons.forEach(( menuIconClass ) => {
          menuIconClass.classList.add("active");
        })
        //gsap.to(svgLogo,{ duration:1,fill:"#000", ease:Linear.easeNone })
        gsap.to(menuItems,{ scale: 1, autoAlpha:1, duration:1 });
      }
    })
  })

  /* if( handle != 'index' )
  {
    var logoSide1 = document.querySelector(".circleMenuWrap .logoSide1");
    var logoSide2 = document.querySelector(".circleMenuWrap .logoSide2");
    gsap.set(logoSide1,{ xPercent : 0, autoAlpha: 1});
    const svgLogo = document.querySelector("a.openMenu.logo");
    svgLogo.addEventListener("pointerenter", function(e){
      if( !svgLogo.classList.contains("active") )
      {
        var logo = svgLogo.querySelector("svg");
        gsap.to(logo, 1, { startAt:{rotation:0}, rotation:360 })
        gsap.to(logoSide1,{ duration:1, xPercent : 150, autoAlpha: 0});
        gsap.to(logoSide2,{ duration:1, xPercent : -150, autoAlpha: 0});
      }
    })
    svgLogo.addEventListener("pointerleave", function(e){
      if( !svgLogo.classList.contains("active") )
      {
        var logo = svgLogo.querySelector("svg");
        gsap.to(logo, 1, { startAt:{rotation:360}, rotation:0 })
        gsap.to(logoSide1,{ duration:1, xPercent : 0, autoAlpha: 1});
        gsap.to(logoSide2,{ duration:1, xPercent : 0, autoAlpha: 1});
      }
    })
  }
  */
}
function productLinkHoverImage( nextHtml ){

  var MarqueeCheck = document.querySelector(".banner_title_marquee");

  if( !MarqueeCheck.classList.contains("doneM") && MarqueeCheck ){
    MarqueeCheck.classList.add("doneM");
    var headerLogoMar = document.querySelectorAll(".banner_title_marquee_part");
      headerLogoMar.forEach(( title ) => {
        const loop = horizontalLoop(title, {
          repeat: -1,
          paused: false,
        });
      });
  }



  //console.log("ff");
  var $response = $(nextHtml);


  var time = 4;
  var $bar,
      $slick,
      isPause,
      tick,
      percentTime;
   var activeSlide = nextHtml.querySelector(".activeSlide");
  var totalSlide = nextHtml.querySelector(".totalSlide");

  var $slick = $response.find('#slider');
  //console.log("$slick",$slick);
  $slick.slick({
    draggable: false,
    adaptiveHeight: false,
    dots: false,
    fade:true,
    arrow: false,
    // autoplay:true,
    mobileFirst: true,
    swipe: false,
    pauseOnDotsHover: false,
    autoplaySpeed: 5000,
    speed: 700,

  });



  // Update current slide number on afterChange
  $slick.on('afterChange', function(event, slick, currentSlide){
    //updateSlideNumbers(currentSlide, slick.slideCount);
  });
    var $productList = nextHtml.querySelector('.column1_products');

  $slick.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      updateSlideNumbers(nextSlide, slick.slideCount);
      var productHoverElements = nextHtml.querySelectorAll(".productHoverElement");

    var $activeEle = productHoverElements[currentSlide];
    var ele = productHoverElements[nextSlide];



    gsap.to($activeEle.querySelector(".elementA"),{ yPercent: 0, autoAlpha: 1, duration:0.7 })
    gsap.to($activeEle.querySelector(".elementB"),{ yPercent: -100, autoAlpha: 0, duration:0.7, onComplete:function(){
      gsap.set($activeEle.querySelector(".elementB"),{ yPercent: 100 });
    } })

    gsap.to(ele.querySelector(".elementA"),{ yPercent: -100, autoAlpha: 0, duration:0.7, onComplete:function(){
      gsap.set(ele.querySelector(".elementA"),{ yPercent: 100 });
      $productList.classList.remove("disableHover");
    } })
    gsap.to(ele.querySelector(".elementB"),{ yPercent: 0, autoAlpha: 1, duration:0.7 })
  });

  activeSlide.innerHTML = "01";
  totalSlide.innerHTML = nextHtml.querySelectorAll(".productHoverElement").length.toString().padStart(2, '0');

  // Function to update slide numbers
  function updateSlideNumbers(currentSlide, totalSlides) {
    var nextSlideNumber = currentSlide + 1;
    activeSlide.innerHTML = nextSlideNumber.toString().padStart(2, '0');
    totalSlide.innerHTML = totalSlides.toString().padStart(2, '0');
  }
  var progressBarCircle = nextHtml.querySelector(".progressBarCircle");
  var pauseText = nextHtml.querySelector(".pauseText");
  var playText = nextHtml.querySelector(".playText");
  var activeSlide = nextHtml.querySelector(".activeSlide");
  var totalSlide = nextHtml.querySelector(".totalSlide");
  gsap.set(playText,{ yPercent: 100, autoAlpha:0 })
  gsap.set(pauseText,{ yPercent: 0, autoAlpha:1 })

  $bar = $response.find('.progressBarCircle');


  var productHoverElements = nextHtml.querySelectorAll(".productHoverElement");

  var totalProducts = productHoverElements.length;
  // Calculate the number of items per group
  var itemsPerGroup = Math.ceil(totalProducts / 3);

  productHoverElements.forEach(function(ele, i) {

    if (i < itemsPerGroup) {
      ele.classList.add('col1');
    } else if (i < itemsPerGroup * 2) {
      ele.classList.add('col2');
    } else {
      ele.classList.add('col3');
    }

    if( ele.getAttribute("index") == 0 )
    {
      ele.classList.add("active");
      gsap.set(ele.querySelector(".elementA"),{ yPercent:100, autoAlpha: 0})
      gsap.set(ele.querySelector(".elementB"),{ yPercent:0, autoAlpha: 1})
    }
    else{
      gsap.set(ele.querySelector(".elementA"),{ yPercent:0, autoAlpha: 1})
      gsap.set(ele.querySelector(".elementB"),{ yPercent:100, autoAlpha: 0})
    }
    var hoverLEemntA = ele.querySelector(".elementA");
    hoverLEemntA.addEventListener("pointerenter", function(e){
      ele = hoverLEemntA.closest(".productHoverElement");
      var eleIndex = ele.getAttribute("index");
      gsap.to(pauseText,{ yPercent: -100, autoAlpha:0, onComplete:function(){
        gsap.set(pauseText,{ yPercent: 100})
      } })
      gsap.to(playText,{ yPercent: 0, autoAlpha:1 })
      $pauseBtn.classList.add("pause");
       isPause = true;
      $slick.slick('slickGoTo', eleIndex);
      //console.log("eleIndex",eleIndex);


      var $activeEle = nextHtml.querySelector(".productHoverElement.active");
      //console.log("$activeEle",$activeEle)

      gsap.to($activeEle.querySelector(".elementA"),{ yPercent: 0, autoAlpha: 1, duration:0.7 })
      gsap.to($activeEle.querySelector(".elementB"),{ yPercent: -100, autoAlpha: 0, duration:0.7, onComplete:function(){
        gsap.set($activeEle.querySelector(".elementB"),{ yPercent: 100 });
      } })

      gsap.to(ele.querySelector(".elementA"),{ yPercent: -100, autoAlpha: 0, duration:0.7, onComplete:function(){
        gsap.set(ele.querySelector(".elementA"),{ yPercent: 100 });
        $productList.classList.remove("disableHover");
      } })
      gsap.to(ele.querySelector(".elementB"),{ yPercent: 0, autoAlpha: 1, duration:0.7 })

      productHoverElements.forEach(function(eleC) {
        eleC.classList.remove("active");
      })
      ele.classList.add("active");
      $productList.classList.add("disableHover");



      //resetProgressbar();
    })
    hoverLEemntA.addEventListener("click", function(e){
      ele = hoverLEemntA.closest(".productHoverElement");
      var eleIndex = ele.getAttribute("index");
      gsap.to(pauseText,{ yPercent: -100, autoAlpha:0, onComplete:function(){
        gsap.set(pauseText,{ yPercent: 100})
      } })
      gsap.to(playText,{ yPercent: 0, autoAlpha:1 })
      $pauseBtn.classList.add("pause");
       isPause = true;
      $slick.slick('slickGoTo', eleIndex);
      //console.log("eleIndex",eleIndex);


      var $activeEle = nextHtml.querySelector(".productHoverElement.active");
      //console.log("$activeEle",$activeEle)

      gsap.to($activeEle.querySelector(".elementA"),{ yPercent: 0, autoAlpha: 1, duration:0.7 })
      gsap.to($activeEle.querySelector(".elementB"),{ yPercent: -100, autoAlpha: 0, duration:0.7, onComplete:function(){
        gsap.set($activeEle.querySelector(".elementB"),{ yPercent: 100 });
      } })

      gsap.to(ele.querySelector(".elementA"),{ yPercent: -100, autoAlpha: 0, duration:0.7, onComplete:function(){
        gsap.set(ele.querySelector(".elementA"),{ yPercent: 100 });
        $productList.classList.remove("disableHover");
      } })
      gsap.to(ele.querySelector(".elementB"),{ yPercent: 0, autoAlpha: 1, duration:0.7 })

      productHoverElements.forEach(function(eleC) {
        eleC.classList.remove("active");
      })
      ele.classList.add("active");
      $productList.classList.add("disableHover");



      //resetProgressbar();
    })
  })





  var $pauseBtn = nextHtml.querySelector('#pausebtn');

  $pauseBtn.addEventListener("click", function() {
      if( $pauseBtn.classList.contains("pause") ){
        isPause = false;
          gsap.to(playText,{ yPercent: -100, autoAlpha:0,onComplete:function(){
            gsap.set(playText,{ yPercent: 100})
          } })
          gsap.to(pauseText,{ yPercent: 0, autoAlpha:1 })
          $pauseBtn.classList.remove("pause");
          //startProgressbar();

      }
      else{
          isPause = true;
          gsap.to(pauseText,{ yPercent: -100, autoAlpha:0, onComplete:function(){
            gsap.set(pauseText,{ yPercent: 100})
          } })
          gsap.to(playText,{ yPercent: 0, autoAlpha:1 })
          $pauseBtn.classList.add("pause")
      }
    });


  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    isPause = false;
    tick = setInterval(interval, 10);
  }

  function interval() {
    if(isPause === false) {
      percentTime += 1 / (time+0.8);
      //console.log("percentTime",percentTime);
      gsap.set($bar,{ '--percent' : percentTime })

      if(percentTime >= 100)
        {
          $slick.slick('slickNext');
          startProgressbar();
        }
    }
  }


  function resetProgressbar() {
    gsap.set($bar,{ '--percent' : 0 })
    clearTimeout(tick);
  }

  startProgressbar();

  /*var $pauseBtn = nextHtml.querySelector("#pausebtn");
  var $slider = nextHtml.querySelector('#slider');
   var $slides = $slider.children,
        slideCount = $slides.length,
        duration = 2,
        fadeSpeed = 1,
        $slide1 = nextHtml.querySelector("#slide1"),
        $slide2 = nextHtml.querySelector("#slide2"),
        $slide3 = nextHtml.querySelector("#slide3"),
        $slide4 = nextHtml.querySelector("#slide4"),
        $slide5 = nextHtml.querySelector("#slide5"),
        $slide6 = nextHtml.querySelector("#slide6"),
        $slide7 = nextHtml.querySelector("#slide7"),
         $slide8 = nextHtml.querySelector("#slide8"),
         $slide9 = nextHtml.querySelector("#slide9"),
         $slide10 = nextHtml.querySelector("#slide10"),
         $slide11= nextHtml.querySelector("#slide11"),
         $slide12= nextHtml.querySelector("#slide12"),

        //$playBtn = nextHtml.querySelector("#playbtn"),
        $resumeBtn = nextHtml.querySelector("#resumebtn"),
        // $stopBtn = nextHtml.querySelector("#stopbtn"),
        // $restartBtn = nextHtml.querySelector("#restartbtn"),
        // $reverseBtn = nextHtml.querySelector("#reversebtn"),
        // $nextBtn = nextHtml.querySelector("#nextbtn"),
        // $prevBtn = nextHtml.querySelector("#prevbtn"),

        // $slide1Btn = nextHtml.querySelector("#slide1btn"),
        // $slide2Btn = nextHtml.querySelector("#slide2btn"),
        // $slide3Btn = nextHtml.querySelector("#slide3btn"),

        $progressBar = nextHtml.querySelector("#progressBar"),
        tl = gsap.timeline({
            paused: true,
            repeat: -1
        });
    var progressBarCircle = nextHtml.querySelector(".progressBarCircle");
    var pauseText = nextHtml.querySelector(".pauseText");
    var playText = nextHtml.querySelector(".playText");
    var activeSlide = nextHtml.querySelector(".activeSlide");
    var totalSlide = nextHtml.querySelector(".totalSlide");
    gsap.set(playText,{ yPercent: 100, autoAlpha:0 })
    gsap.set(pauseText,{ yPercent: 0, autoAlpha:1 })
    totalSlide.innerHTML = slideCount.toString().padStart(2, '0');
    activeSlide.innerHTML = '01';
    activeSlide.classList.add("active");





    updateZindex();




    function animateSlide1() {
        //console.log("111")
        var slideTL12 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide12]
        });

        slideTL12
            .add("slide12fade")
            .to($slide12, {
              duration: fadeSpeed,
              autoAlpha: 0 ,
              onComplete:function(){
                activeSlide.innerHTML = '01';

              }
            })
            .add("slide12afterfade")
            .to($slide12, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL12;
    }

    function animateSlide2() {
        //console.log("2")
        var slideTL1 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide1]
        });

        slideTL1
            .add("slide1fade")
            .set($slide1, { autoAlpha: 1 })
            .to($slide1, { duration: fadeSpeed, autoAlpha: 0, onComplete:function(){
              activeSlide.innerHTML = '02';
            } })

            .to($slide1, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 })
           .add("slide1afterfade");
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL1;
    }

    function animateSlide3() {
        var slideTL2 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide2]
        });

        slideTL2
            .add("slide2fade")
            .to($slide2, { duration: fadeSpeed, autoAlpha: 0,  onComplete:function(){
              activeSlide.innerHTML = '03';
            } })
            .add("slide2afterfade")
            .to($slide2, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL2;
    }
    function animateSlide4() {
        var slideTL3 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide3]
        });

        slideTL3
            .add("slide3fade")
            .to($slide3, { duration: fadeSpeed, autoAlpha: 0,  onComplete:function(){
              activeSlide.innerHTML = '04';
            } })
            .add("slide3afterfade")
            .to($slide3, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL3;
    }
    function animateSlide5() {
        var slideTL4 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide4]
        });

        slideTL4
            .add("slide4fade")
            .to($slide4, { duration: fadeSpeed, autoAlpha: 0 , onComplete:function(){
              activeSlide.innerHTML = '05';
            } })
            .add("slide4afterfade")
            .to($slide4, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL4;
    }
    function animateSlide6() {
        var slideTL5 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide5]
        });

        slideTL5
            .add("slide5fade")
            .to($slide5, { duration: fadeSpeed, autoAlpha: 0 , onComplete:function(){
              activeSlide.innerHTML = '06';
            } })
            .add("slide5afterfade")
            .to($slide5, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL5;
    }
    function animateSlide7() {
        var slideTL6 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide6]
        });

        slideTL6
            .add("slide6fade")
            .to($slide6, { duration: fadeSpeed, autoAlpha: 0 , onComplete:function(){
              activeSlide.innerHTML = '07';
            } })
            .add("slide6afterfade")
            .to($slide6, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL6;
    }
    function animateSlide8() {
        var slideTL7 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide7]
        });

        slideTL7
            .add("slide7fade")
            .to($slide7, { duration: fadeSpeed, autoAlpha: 0 , onComplete:function(){
              activeSlide.innerHTML = '08';
            } })
            .add("slide7afterfade")
            .to($slide7, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL7;
    }
    function animateSlide9() {
        var slideTL8 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide8]
        });

        slideTL8
            .add("slide8fade")
            .to($slide8, { duration: fadeSpeed, autoAlpha: 0 , onComplete:function(){
              activeSlide.innerHTML = '09';
            } })
            .add("slide8afterfade")
            .to($slide8, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });

        return slideTL8;
    }
    function animateSlide10() {
        var slideTL9 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide9]
        });

        slideTL9
            .add("slide9fade")
            .to($slide9, { duration: fadeSpeed, autoAlpha: 0 , onComplete:function(){
              activeSlide.innerHTML = '10';
            } })
            .add("slide9afterfade")
            .to($slide9, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL9;
    }
    function animateSlide11() {
        var slideTL10 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide10]
        });

        slideTL10
            .add("slide10fade")
            .to($slide10, { duration: fadeSpeed, autoAlpha: 0 , onComplete:function(){
              activeSlide.innerHTML = '11';
            } })
            .add("slide10afterfade")
            .to($slide10, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL10;
    }
    function animateSlide12() {
        var slideTL11 = gsap.timeline({
            onComplete: prepNext,
            onCompleteParams: [$slide11]
        });

        slideTL11
            .add("slide11fade")
            .to($slide11, { duration: fadeSpeed, autoAlpha: 0 , onComplete:function(){
              activeSlide.innerHTML = '12';
            } })
            .add("slide11afterfade")
            .to($slide11, { duration: duration })
            .set(progressBarCircle, { '--percent': 0 })
            .to(progressBarCircle, { '--percent': 100, duration: 2 });
            // .set($progressBar,{ scaleX: 0},0)
            // .fromTo($progressBar, duration,{ scaleX: 0, transformOrigin: "0px 0px" }, { scaleX: 1, transformOrigin: "0px 0px", ease: "none" });

        return slideTL11;
    }

    function updateZindex(e) {
      //console.log("e---",e);
      console.log("e",e)
        Array.from($slides).forEach(function(slide, i) {
            slide.style.zIndex = slideCount - i;
        });
      // var listItems = nextHtml.querySelectorAll("#slider .slide");

      // var maxZIndex = 7; // Start with a very low number
      // var maxZIndexElement = ''; // To store the element with the max z-index

      // listItems.forEach(function(item) {
      //     // Get the computed z-index value
      //     var zIndex = window.getComputedStyle(item).zIndex;

      //     // Convert zIndex to a number if it's not 'auto'
      //     zIndex = isNaN(parseInt(zIndex)) ? 0 : parseInt(zIndex);

      //     // Update the max zIndex and the corresponding element
      //     if (maxZIndexElement=='') {
      //         maxZIndex = zIndex;
      //         maxZIndexElement = item;
      //     }
      // });

      // maxZIndexElement now holds the <li> with the highest z-index
      // console.log('Element with max z-index:', maxZIndexElement);
      // console.log('Max z-index:', maxZIndex);
      // var firstLi = nextHtml.querySelectorAll('#slider .slide');
      // console.log(firstLi[0]);
      // var slideID = firstLi[0].getAttribute("id").split("ide");
      // var slideNumber = slideID[1];
      // //if()
      // console.log("slideNumber",slideNumber);
    }
    function prepNext(slide) {

        slide.parentNode.appendChild(slide);
        updateZindex();
        gsap.set(slide, { autoAlpha: 1 });
        //console.log("fff");
    }

    function showProgress(timeline) {

        gsap.set($progressBar, { scaleX: timeline.progress(), transformOrigin: "0px 0px" });
        gsap.set(progressBarCircle, { '--percent': 0 });
        //console.log("Hhii");



    }

    //window.addEventListener("load", function() {
        tl
            .add(animateSlide1(), "slide1")
            .add(animateSlide2(), "slide2")
            .add(animateSlide3(), "slide3")
            .add(animateSlide4(), "slide4")
            .add(animateSlide5(), "slide5")
            .add(animateSlide6(), "slide6")
            .add(animateSlide7(), "slide7")
            .add(animateSlide8(), "slide8")
            .add(animateSlide9(), "slide9")
            .add(animateSlide10(), "slide10")
          .add(animateSlide11(), "slide11")
          .add(animateSlide12(), "slide12")
            .progress(1).progress(0)
            .play();
    //});
    // var productHoverElements = nextHtml.querySelectorAll(".productHoverElement");
    // productHoverElements.forEach(function(ele, i) {
    //   if( ele.getAttribute("index") == 1 )
    //   {
    //     //show shop
    //     ele.classList.add("active");
    //     gsap.set(ele.querySelector(".elementA"),{ yPercent:100, autoAlpha: 0})
    //     gsap.set(ele.querySelector(".elementB"),{ yPercent:0, autoAlpha: 1})
    //   }
    //   else{
    //     gsap.set(ele.querySelector(".elementA"),{ yPercent:0, autoAlpha: 1})
    //     gsap.set(ele.querySelector(".elementB"),{ yPercent:100, autoAlpha: 0})
    //   }
    //   ele.addEventListener("pointerenter", function(e){
    //     var eleIndex = ele.getAttribute("index");
    //     updateZindex();
    //     if( eleIndex == 1 ){ tl.seek("slide1").resume();}
    //     if( eleIndex == 2 ){ tl.seek("slide2").resume();}
    //     if( eleIndex == 3 ){ tl.seek("slide3").resume();}
    //     if( eleIndex == 4 ){ tl.seek("slide4").resume();}
    //     if( eleIndex == 5 ){ tl.seek("slide5").resume();}
    //     if( eleIndex == 6 ){ tl.seek("slide6").resume();}
    //     if( eleIndex == 7 ){ tl.seek("slide7").resume();}
    //     //tl.pause();
    //   })
    // })
  var productHoverElements = nextHtml.querySelectorAll(".productHoverElement");

productHoverElements.forEach(function(ele) {
    var index = ele.getAttribute("index");
    var elementA = ele.querySelector(".elementA");
    var elementB = ele.querySelector(".elementB");

    // Initial setup based on index
    if (index == 1) {
        ele.classList.add("active");
        gsap.set(elementA, { yPercent: 100, autoAlpha: 0 });
        gsap.set(elementB, { yPercent: 0, autoAlpha: 1 });
    } else {
        gsap.set(elementA, { yPercent: 0, autoAlpha: 1 });
        gsap.set(elementB, { yPercent: 100, autoAlpha: 0 });
    }

    // Hover interaction
    ele.addEventListener("pointerenter", function(e) {
        productHoverElements.forEach(function(otherEle) {
            if (otherEle !== ele) {
                otherEle.classList.remove("active");
                gsap.set(otherEle.querySelector(".elementA"), { yPercent: 0, autoAlpha: 1 });
                gsap.set(otherEle.querySelector(".elementB"), { yPercent: 100, autoAlpha: 0 });
            }
        });

        ele.classList.add("active");

        // Timeline control based on index
        //tl.pause();
        tl.seek("slide" + index).play(); // Assuming you have labels like "slide1", "slide2", etc.
    });
});

    $pauseBtn.addEventListener("click", function() {
      if( $pauseBtn.classList.contains("pause") ){

          tl.resume();
          //$pauseBtn.innerHTML = 'Pause';
          gsap.to(playText,{ yPercent: -100, autoAlpha:0,onComplete:function(){
            gsap.set(playText,{ yPercent: 100})
          } })
          gsap.to(pauseText,{ yPercent: 0, autoAlpha:1 })
          $pauseBtn.classList.remove("pause");
      }
      else{
          tl.pause();
          //$pauseBtn.innerHTML = 'Play';
          gsap.to(pauseText,{ yPercent: -100, autoAlpha:0, onComplete:function(){
            gsap.set(pauseText,{ yPercent: 100})
          } })
          gsap.to(playText,{ yPercent: 0, autoAlpha:1 })
          $pauseBtn.classList.add("pause")

      }
    });


    // $slide1Btn.addEventListener("click", function() {
    //     tl.play("slide1afterfade");
    // });

    // $slide2Btn.addEventListener("click", function() {
    //     tl.play("slide2afterfade");
    // });

    // $slide3Btn.addEventListener("click", function() {
    //     tl.play("slide3afterfade");
    // });

    // $playBtn.addEventListener("click", function() {
    //     tl.play("slide1afterfade");
    // });


    // $resumeBtn.addEventListener("click", function() {
    //     tl.resume();
    // });

    // $stopBtn.addEventListener("click", function() {
    //     tl.pause(0);
    // });

    // $restartBtn.addEventListener("click", function() {
    //     tl.restart();
    // });

    // $reverseBtn.addEventListener("click", function() {
    //     tl.reverse();
    // });

    // $slider.addEventListener("mouseenter", function() {
    //     tl.pause();
    // });

    // $slider.addEventListener("mouseleave", function() {
    //     tl.resume();
    // });

  /*var product_hover_images = nextHtml.querySelectorAll(".product_hover_image");
  product_hover_images.forEach(( product_hover_image ) => {
    gsap.set(product_hover_images,{opacity:0});
  })
  var allProductLinks = nextHtml.querySelectorAll("a.hoverChangeImage");
  allProductLinks.forEach(( productLink ) => {
    productLink.addEventListener("pointerenter", function(e){
      var imageClass = nextHtml.querySelector('.hover_product_'+productLink.getAttribute("image-id"));
      var activeBgElement = nextHtml.querySelector(".bg_image.active");
      activeBgElement.classList.remove("active");
      gsap.to(activeBgElement,{ opacity:0, duration:1 });
      gsap.to(imageClass,{ opacity:1, duration:1 });
      imageClass.classList.add("active");
    })
  });*/
}
function revealImages( nextHtml )
{
  gsap.registerPlugin(ScrollTrigger);
  let revealImages = nextHtml.querySelectorAll(".imageblkWrap .imageblk img");
  revealImages.forEach((revealImage ,index) => {
    gsap.set(revealImage,{ scale:1.3 })
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: revealImage,
        start: "top center",
        end: "top bottom",
        toggleActions: "play none reverse reverse"
      }
    });
    tl.to(revealImage, 1, {
      scale: 1,
      ease: Power2.out
    });
  })
}

function productCardThumbnails( nextHtml )
{

  var productCards = nextHtml.querySelectorAll(".customProductCard .card");
  productCards.forEach(( productCard ) => {
    //console.log("jj ",productCard);
    let ImageOne = productCard.querySelector(".customPCardImage_0");
    let ImageTwo = productCard.querySelector(".customPCardImage_1");
    if( ImageTwo )
    {
      gsap.set(ImageOne,{ xPercent:0 });
      gsap.set(ImageTwo,{ xPercent:125 });
      var tl = new TimelineLite({ paused : true, ease:"none", stagger: 0.1 });
      tl.to( ImageOne, 1, {xPercent : -125, duration: 1 });
      tl.to( ImageTwo, 1, {xPercent : 0, duration: 1 },0);
        productCard.addEventListener("pointerenter", function(e) {
          if (window.matchMedia("(min-width: 768px)").matches) {
            tl.play();
          }
        })
        productCard.addEventListener("pointerleave", function(e) {
          if (window.matchMedia("(min-width: 768px)").matches) {
            tl.reverse();
          }
        })
    }
  })
}
function productCardThumbnails_recomended( nextHtml )
{
  //     var bigBtns = nextHtml.querySelectorAll(".col2b");
  // console.log("bigBtns",bigBtns);
  //     bigBtns.forEach(( bigBtn ) => {
  //         gsap.from(bigBtn, {
  //             scrollTrigger: {
  //                 start: 'bottom bottom',
  //                 trigger: bigBtn,
  //                 onEnter() {
  //                     bigBtn.classList.add('animate_gallery_grid');
  //                     setTimeout(() => {
  //                         bigBtn.classList.remove('animate_gallery_grid');
  //                     }, 1500);
  //                 },
  //                 onEnterBack() {
  //                     bigBtn.classList.add('animate_gallery_grid');
  //                     setTimeout(() => {
  //                         bigBtn.classList.remove('animate_gallery_grid');
  //                     }, 1500);
  //                 },
  //                 //once: true,
  //             }
  //         });
  //     })

  var productCards = nextHtml.querySelectorAll(".related-products-grid .customProductCard .card");
  productCards.forEach(( productCard ) => {
    let ImageOne = productCard.querySelector(".customPCardImage_0");
    let ImageTwo = productCard.querySelector(".customPCardImage_1");
    if( ImageTwo )
    {
      gsap.set(ImageOne,{ xPercent:0 });
      gsap.set(ImageTwo,{ xPercent:125 });
      var tl = new TimelineLite({ paused : true, ease:"none", stagger: 0.1 });
      tl.to( ImageOne, 1, {xPercent : -125 });
      tl.to( ImageTwo, 1, {xPercent : 0 },0);

        productCard.addEventListener("pointerenter", function(e) {
          if (window.matchMedia("(min-width: 768px)").matches) {
            tl.play();
          }
        })
        productCard.addEventListener("pointerleave", function(e) {
          if (window.matchMedia("(min-width: 768px)").matches) {
            tl.reverse();
          }
        })

    }
  })
}
function __productCardThumbnails( nextHtml )
{
  //console.log("nextHtml",nextHtml);
  // var mainElement = document.querySelector("main");

  // if( !mainElement.classList.contains("loaded"))
  // {

    var galleryImages = nextHtml.querySelectorAll(".customProductCard .gallery-images");
    //console.log("galleryImages",galleryImages);
    galleryImages.forEach(( galleryImage ) => {


      gsap.set(galleryImage,{opacity:0});
    })

    var productCards = nextHtml.querySelectorAll(".customProductCard .card");
    productCards.forEach(( productCard ) => {
      var otherImages = productCard.querySelectorAll(".product-other-images");
      gsap.set(otherImages,{ xPercent: 100});
      var tl = new TimelineLite({ paused : true });
      tl.to( otherImages, 1, {xPercent : 0 });
      productCard.addEventListener("pointerenter", function(e) {
          tl.play();
      })
      productCard.addEventListener("pointerleave", function(e) {
          tl.reverse();
      })

      var thumbnailImages = productCard.querySelectorAll(".thumbnail-image")
      thumbnailImages.forEach(( thumbnailImage ) => {
        thumbnailImage.addEventListener("click", function(e) {

          if( !thumbnailImage.classList.contains("activeThumb") )
          {
            thumbnailImages.forEach(( eachImage ) => {
              eachImage.classList.remove("activeThumb");
            })
            thumbnailImage.classList.add("activeThumb");
            //console.log('thumbnailImage.getAttribute+("image-id")',thumbnailImage.getAttribute("image-id"))
            var currentImage = productCard.querySelector('.gallery-image-'+thumbnailImage.getAttribute("image-id"));
            var activeImage = productCard.querySelector(".motion-reduce.active");
            gsap.to(activeImage,{ opacity:0, duration:1 });
            activeImage.classList.remove("active");
            gsap.to(currentImage,{ opacity:1, duration:1 });
            currentImage.classList.add("active");
          }

        })
      })

    })
  //}
}
function _productCardThumbnails_recomended( nextHtml )
{
  //console.log("nextHtml herer",nextHtml);
  var galleryImages = nextHtml.querySelectorAll(".customProductCard .gallery-images");
  galleryImages.forEach(( galleryImage ) => {
    gsap.set(galleryImage,{opacity:0});
  })

  var productCards = nextHtml.querySelectorAll(".customProductCard .card");
  productCards.forEach(( productCard ) => {
    var otherImages = productCard.querySelectorAll(".product-other-images");
    gsap.set(otherImages,{ xPercent: 100});
    var tl = new TimelineLite({ paused : true });
    tl.to( otherImages, 1, {xPercent : 0 });
    productCard.addEventListener("pointerenter", function(e) {
        tl.play();
    })
    productCard.addEventListener("pointerleave", function(e) {
        tl.reverse();
    })

    var thumbnailImages = productCard.querySelectorAll(".thumbnail-image")
    thumbnailImages.forEach(( thumbnailImage ) => {
      thumbnailImage.addEventListener("click", function(e) {

        if( !thumbnailImage.classList.contains("activeThumb") )
        {
          thumbnailImages.forEach(( eachImage ) => {
            eachImage.classList.remove("activeThumb");
          })
          thumbnailImage.classList.add("activeThumb");
          //console.log('thumbnailImage.getAttribute+("image-id")',thumbnailImage.getAttribute("image-id"))
          var currentImage = productCard.querySelector('.gallery-image-'+thumbnailImage.getAttribute("image-id"));
          var activeImage = productCard.querySelector(".motion-reduce.active");
          gsap.to(activeImage,{ opacity:0, duration:1 });
          activeImage.classList.remove("active");
          gsap.to(currentImage,{ opacity:1, duration:1 });
          currentImage.classList.add("active");
        }

      })
    })

  })
}

function cardMarquee( nextHtml )
{
  var allTitleMaquees = nextHtml.querySelectorAll(".product_title_marquee");
  allTitleMaquees.forEach(( marquee ) => {

    var productTitles = marquee.querySelectorAll(".product_title");
    productTitles.forEach(( title ) => {
      const loop = horizontalLoop(title, {
        repeat: -1,
        paused: false,
      });
    });
  })
}
function horizontalLoop(items, config) {
        items = gsap.utils.toArray(items);
        config = config || {};
        let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
        length = items.length,
        startX = items[0].offsetLeft,
        times = [],
        widths = [],
        xPercents = [],
        curIndex = 0,
        pixelsPerSecond = (config.speed || 1) * 100,
        snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
        totalWidth, curX, distanceToStart, distanceToLoop, item, i;
        gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
            xPercent: (i, el) => {
                let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
                xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
                return xPercents[i];
            }
        });
        gsap.set(items, {x: 0});
        totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
        for (i = 0; i < length; i++) {
            item = items[i];
            curX = xPercents[i] / 100 * widths[i];
            distanceToStart = item.offsetLeft + curX - startX;
            distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
            tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
            .fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
            .add("label" + i, distanceToStart / pixelsPerSecond);
            times[i] = distanceToStart / pixelsPerSecond;
        }
        function toIndex(index, vars) {
            vars = vars || {};
            (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
            let newIndex = gsap.utils.wrap(0, length, index),
            time = times[newIndex];
            if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
            vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())};
            time += tl.duration() * (index > curIndex ? 1 : -1);
            }
            curIndex = newIndex;
            vars.overwrite = true;
            return tl.tweenTo(time, vars);
        }
        tl.next = vars => toIndex(curIndex+1, vars);
        tl.previous = vars => toIndex(curIndex-1, vars);
        tl.current = () => curIndex;
        tl.toIndex = (index, vars) => toIndex(index, vars);
        tl.times = times;
        tl.progress(1, true).progress(0, true); // pre-render for performance
        if (config.reversed) {
            tl.vars.onReverseComplete();
            tl.reverse();
        }
        return tl;
    }

function facetFilters() {
  //Header Menu
  gsap.registerPlugin(ScrollTrigger);
  const menuIcon = document.querySelector("a.openMenu");
  const menuItems = document.querySelector(".circleMenu");
  gsap.set(menuItems,{ scale: 0.35 });
  menuIcon.addEventListener("click", function(e){
    if( menuIcon.classList.contains("active") )
    {
      menuIcon.classList.remove("active");
      gsap.to(menuItems,{ scale: 0.35, duration:1 });
    }
    else
    {
      menuIcon.classList.add("active");
      gsap.to(menuItems,{ scale: 1, duration:1 });
      //console.log("Shiow");
    }

  })
  // Product Card
  var galleryImages = document.querySelectorAll(".customProductCard .gallery-images");
  galleryImages.forEach(( galleryImage ) => {
    gsap.set(galleryImage,{opacity:0});
  })

  var productCards = document.querySelectorAll(".customProductCard .card");
  productCards.forEach(( productCard ) => {
    var otherImages = productCard.querySelectorAll(".product-other-images");
    gsap.set(otherImages,{ xPercent: 100});
    var tl = new TimelineLite({ paused : true });
    tl.to( otherImages, 1, {xPercent : 0 });
    productCard.addEventListener("pointerenter", function(e) {
        tl.play();
    })
    productCard.addEventListener("pointerleave", function(e) {
        tl.reverse();
    })

    var thumbnailImages = productCard.querySelectorAll(".thumbnail-image")
    thumbnailImages.forEach(( thumbnailImage ) => {
      thumbnailImage.addEventListener("click", function(e) {

        if( !thumbnailImage.classList.contains("activeThumb") )
        {
          thumbnailImages.forEach(( eachImage ) => {
            eachImage.classList.remove("activeThumb");
          })
          thumbnailImage.classList.add("activeThumb");
          //console.log('thumbnailImage.getAttribute+("image-id")',thumbnailImage.getAttribute("image-id"))
          var currentImage = productCard.querySelector('.gallery-image-'+thumbnailImage.getAttribute("image-id"));
          var activeImage = productCard.querySelector(".motion-reduce.active");
          gsap.to(activeImage,{ opacity:0, duration:1 });
          activeImage.classList.remove("active");
          gsap.to(currentImage,{ opacity:1, duration:1 });
          currentImage.classList.add("active");
        }

      })
    })

  })

  // MARQUEE
  var allTitleMaquees = document.querySelectorAll(".product_title_marquee");
  allTitleMaquees.forEach(( marquee ) => {
    var productTitles = marquee.querySelectorAll(".product_title");
    productTitles.forEach(( title ) => {
      const loop = horizontalLoop(title, {
        repeat: -1,
        paused: false,
      });
    });
  })
}

function verticalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};
    let onChange = config.onChange,
    lastIndex = 0,
    tl = gsap.timeline({repeat: config.repeat, onUpdate: onChange && function() {
        let i = tl.closestIndex()
        if (lastIndex !== i) {
            lastIndex = i;
            onChange(items[i], i);
        }
    }, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
    length = items.length,
    startY = items[0].offsetTop,
    times = [],
    heights = [],
    spaceBefore = [],
    yPercents = [],
    curIndex = 0,
    center = config.center,
    clone = obj => {
        let result = {}, p;
        for (p in obj) {
            result[p] = obj[p];
        }
        return result;
    },
    pixelsPerSecond = (config.speed || 1) * 100,
    snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
    timeOffset = 0,
    container = center === true ? items[0].parentNode : gsap.utils.toArray(center)[0] || items[0].parentNode,
    totalHeight,
    getTotalHeight = () => items[length-1].offsetTop + yPercents[length-1] / 100 * heights[length-1] - startY + spaceBefore[0] + items[length-1].offsetHeight * gsap.getProperty(items[length-1], "scaleY") + (parseFloat(config.paddingBottom) || 0),
    populateHeights = () => {
        let b1 = container.getBoundingClientRect(), b2;
        items.forEach((el, i) => {
            heights[i] = parseFloat(gsap.getProperty(el, "height", "px"));
            yPercents[i] = snap(parseFloat(gsap.getProperty(el, "y", "px")) / heights[i] * 100 + gsap.getProperty(el, "yPercent"));
            b2 = el.getBoundingClientRect();
            spaceBefore[i] = b2.top - (i ? b1.bottom : b1.top);
            b1 = b2;
        });
        gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
            yPercent: i => yPercents[i]
        });
        totalHeight = getTotalHeight();
    },
    timeWrap,
    populateOffsets = () => {
        timeOffset = center ? tl.duration() * (container.offsetWidth / 2) / totalHeight : 0;
        center && times.forEach((t, i) => {
            times[i] = timeWrap(tl.labels["label" + i] + tl.duration() * heights[i] / 2 / totalHeight - timeOffset);
        });
    },
    getClosest = (values, value, wrap) => {
        let i = values.length,
            closest = 1e10,
            index = 0, d;
        while (i--) {
            d = Math.abs(values[i] - value);
            if (d > wrap / 2) {
            d = wrap - d;
            }
            if (d < closest) {
            closest = d;
            index = i;
            }
        }
        return index;
    },
    populateTimeline = () => {
        let i, item, curY, distanceToStart, distanceToLoop;
        tl.clear();
        for (i = 0; i < length; i++) {
            item = items[i];
            curY = yPercents[i] / 100 * heights[i];
            distanceToStart = item.offsetTop + curY - startY + spaceBefore[0];
            distanceToLoop = distanceToStart + heights[i] * gsap.getProperty(item, "scaleY");
            tl.to(item, {yPercent: snap((curY - distanceToLoop) / heights[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
            .fromTo(item, {yPercent: snap((curY - distanceToLoop + totalHeight) / heights[i] * 100)}, {yPercent: yPercents[i], duration: (curY - distanceToLoop + totalHeight - curY) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
            .add("label" + i, distanceToStart / pixelsPerSecond);
            times[i] = distanceToStart / pixelsPerSecond;
        }
        timeWrap = gsap.utils.wrap(0, tl.duration());
    },
    refresh = (deep) => {
        let progress = tl.progress();
        tl.progress(0, true);
        populateHeights();
        deep && populateTimeline();
        populateOffsets();
        deep && tl.draggable ? tl.time(times[curIndex], true) : tl.progress(progress, true);
    },
    proxy;
    gsap.set(items, {y: 0});
    populateHeights();
    populateTimeline();
    populateOffsets();
    window.addEventListener("resize", () => refresh(true));
    function toIndex(index, vars) {
        vars = clone(vars);
        (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
        let newIndex = gsap.utils.wrap(0, length, index),
            time = times[newIndex];
        if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
            time += tl.duration() * (index > curIndex ? 1 : -1);
        }
        if (vars.revolutions) {
            time += tl.duration() * Math.round(vars.revolutions);
            delete vars.revolutions;
        }
        if (time < 0 || time > tl.duration()) {
            vars.modifiers = {time: timeWrap};
        }
        curIndex = newIndex;
        vars.overwrite = true;
        gsap.killTweensOf(proxy);
        return tl.tweenTo(time, vars);
    }
    tl.elements = items;
    tl.next = vars => toIndex(curIndex+1, vars);
    tl.previous = vars => toIndex(curIndex-1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.closestIndex = setCurrent => {
        let index = getClosest(times, tl.time(), tl.duration());
        setCurrent && (curIndex = index);
        return index;
    };
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
    }
    if (config.draggable && typeof(Draggable) === "function") {
        proxy = document.createElement("div")
        let wrap = gsap.utils.wrap(0, 1),
        ratio, startProgress, draggable, dragSnap,
        align = () => tl.progress(wrap(startProgress + (draggable.startY - draggable.y) * ratio)),
        syncIndex = () => tl.closestIndex(true);
        typeof(InertiaPlugin) === "undefined" && console.warn("InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club");
        draggable = Draggable.create(proxy, {
            trigger: items[0].parentNode,
            type: "y",
            onPressInit() {
            gsap.killTweensOf(tl);
            startProgress = tl.progress();
            refresh();
                ratio = 1 / totalHeight;
                gsap.set(proxy, {y: startProgress / -ratio})
            },
            onDrag: align,
            onThrowUpdate: align,
            inertia: true,
            snap: value => {
                let time = -(value * ratio) * tl.duration(),
                    wrappedTime = timeWrap(time),
                    snapTime = times[getClosest(times, wrappedTime, tl.duration())],
                    dif = snapTime - wrappedTime;
                Math.abs(dif) > tl.duration() / 2 && (dif += dif < 0 ? tl.duration() : -tl.duration());
                return (time + dif) / tl.duration() / -ratio;
            },
            onRelease: syncIndex,
            onThrowComplete: syncIndex
        })[0];
        tl.draggable = draggable;
    }
    tl.closestIndex(true);
    onChange && onChange(items[curIndex], curIndex);
    return tl;
}
